type IconProps = React.ComponentProps<'svg'>

export function FaceContentIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M14.1992 12.2412C14.4569 11.9616 14.8895 11.9174 15.2002 12.1504C15.5107 12.3835 15.589 12.8112 15.3926 13.1367L15.3496 13.2002L15.3457 13.2051C15.3441 13.2072 15.3422 13.2099 15.3398 13.2129C15.3349 13.2193 15.3282 13.2283 15.3203 13.2383C15.3045 13.2582 15.2825 13.2855 15.2549 13.3184C15.1994 13.3844 15.1197 13.4745 15.0176 13.5811C14.8136 13.7939 14.5154 14.0754 14.1289 14.3564C13.3586 14.9167 12.2066 15.5 10.75 15.5C9.29335 15.5 8.14142 14.9167 7.37109 14.3564C6.98462 14.0754 6.68636 13.7939 6.48242 13.5811C6.38027 13.4745 6.30056 13.3844 6.24512 13.3184C6.21751 13.2855 6.1955 13.2582 6.17969 13.2383C6.17177 13.2283 6.16506 13.2193 6.16016 13.2129C6.15783 13.2099 6.15593 13.2072 6.1543 13.2051L6.15039 13.2012C5.90194 12.8699 5.9687 12.399 6.2998 12.1504C6.61049 11.9174 7.04315 11.9616 7.30078 12.2412L7.34863 12.2988C7.34954 12.3 7.35188 12.3021 7.35547 12.3066C7.3628 12.3159 7.37554 12.332 7.39355 12.3535C7.42989 12.3968 7.48708 12.4632 7.56445 12.5439C7.71985 12.7061 7.95302 12.9247 8.25391 13.1436C8.85856 13.5833 9.70678 14 10.75 14C11.7932 14 12.6414 13.5833 13.2461 13.1436C13.547 12.9247 13.7802 12.7061 13.9355 12.5439C14.0129 12.4632 14.0701 12.3968 14.1064 12.3535C14.1245 12.332 14.1372 12.3159 14.1445 12.3066L14.1504 12.2988L14.1992 12.2412Z"
          fill="currentColor"
        />
        <path
          d="M5.26562 7.41699C5.58195 7.14959 6.05583 7.18954 6.32324 7.50586C6.61882 7.85539 6.94598 8 7.25 8C7.56161 8 7.89781 7.84952 8.16895 7.5166C8.4305 7.19556 8.9025 7.14677 9.22363 7.4082C9.54481 7.66978 9.59263 8.14269 9.33105 8.46387C8.81221 9.10073 8.06822 9.5 7.25 9.5C6.42411 9.5 5.70112 9.09488 5.17676 8.47461C4.90935 8.15828 4.9493 7.6844 5.26562 7.41699Z"
          fill="currentColor"
        />
        <path
          d="M12.2656 7.41699C12.582 7.14959 13.0558 7.18954 13.3232 7.50586C13.6188 7.85539 13.946 8 14.25 8C14.5616 8 14.8978 7.84952 15.1689 7.5166C15.4305 7.19556 15.9025 7.14677 16.2236 7.4082C16.5448 7.66978 16.5926 8.14269 16.3311 8.46387C15.8122 9.10073 15.0682 9.5 14.25 9.5C13.4241 9.5 12.7011 9.09488 12.1768 8.47461C11.9093 8.15828 11.9493 7.6844 12.2656 7.41699Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function FaceFrownIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M10.75 12C12.2066 12 13.3586 12.5833 14.1289 13.1436C14.5154 13.4246 14.8136 13.7061 15.0176 13.9189C15.1197 14.0255 15.1994 14.1156 15.2549 14.1816C15.2825 14.2145 15.3045 14.2418 15.3203 14.2617C15.3282 14.2717 15.3349 14.2807 15.3398 14.2871C15.3422 14.2901 15.3441 14.2928 15.3457 14.2949L15.3496 14.2988L15.3926 14.3633C15.589 14.6888 15.5107 15.1165 15.2002 15.3496C14.8895 15.5826 14.4569 15.5384 14.1992 15.2588L14.1504 15.2012C14.1492 15.1997 14.1474 15.197 14.1445 15.1934C14.1372 15.1841 14.1245 15.168 14.1064 15.1465C14.0701 15.1032 14.0129 15.0368 13.9355 14.9561C13.7802 14.7939 13.547 14.5753 13.2461 14.3564C12.6414 13.9167 11.7932 13.5 10.75 13.5C9.70678 13.5 8.85856 13.9167 8.25391 14.3564C7.95302 14.5753 7.71985 14.7939 7.56445 14.9561C7.48708 15.0368 7.42989 15.1032 7.39355 15.1465C7.37554 15.168 7.3628 15.1841 7.35547 15.1934L7.34863 15.2012C7.09983 15.5313 6.63071 15.5978 6.2998 15.3496C5.9687 15.101 5.90194 14.6311 6.15039 14.2998L6.1543 14.2949C6.15593 14.2928 6.15783 14.2901 6.16016 14.2871C6.16506 14.2807 6.17177 14.2717 6.17969 14.2617C6.1955 14.2418 6.21751 14.2145 6.24512 14.1816C6.30056 14.1156 6.38027 14.0255 6.48242 13.9189C6.68636 13.7061 6.98462 13.4246 7.37109 13.1436C8.14142 12.5833 9.29335 12 10.75 12Z"
          fill="currentColor"
        />
        <path
          d="M7.75 6.5C8.44036 6.5 9 7.05964 9 7.75C9 8.44036 8.44036 9 7.75 9C7.05964 9 6.5 8.44036 6.5 7.75C6.5 7.05964 7.05964 6.5 7.75 6.5Z"
          fill="currentColor"
        />
        <path
          d="M13.75 6.5C14.4404 6.5 15 7.05964 15 7.75C15 8.44036 14.4404 9 13.75 9C13.0596 9 12.5 8.44036 12.5 7.75C12.5 7.05964 13.0596 6.5 13.75 6.5Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function FaceHappyIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.25 12C15.6642 12 16 12.3358 16 12.75C16 13.8767 15.338 14.9461 14.4131 15.7051C13.4734 16.476 12.1823 17 10.75 17C9.31774 17 8.0266 16.476 7.08691 15.7051C6.16198 14.9461 5.5 13.8767 5.5 12.75C5.5 12.3358 5.83579 12 6.25 12H15.25ZM7.19043 13.5C7.35843 13.8519 7.63774 14.2164 8.03809 14.5449C8.72325 15.1071 9.6819 15.5 10.75 15.5C11.8181 15.5 12.7767 15.1071 13.4619 14.5449C13.8623 14.2164 14.1416 13.8519 14.3096 13.5H7.19043Z"
          fill="currentColor"
        />
        <path
          d="M7.75 6.5C8.44036 6.5 9 7.05964 9 7.75C9 8.44036 8.44036 9 7.75 9C7.05964 9 6.5 8.44036 6.5 7.75C6.5 7.05964 7.05964 6.5 7.75 6.5Z"
          fill="currentColor"
        />
        <path
          d="M13.75 6.5C14.4404 6.5 15 7.05964 15 7.75C15 8.44036 14.4404 9 13.75 9C13.0596 9 12.5 8.44036 12.5 7.75C12.5 7.05964 13.0596 6.5 13.75 6.5Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function FaceNeutralIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M14.75 13C15.1642 13 15.5 13.3358 15.5 13.75C15.5 14.1642 15.1642 14.5 14.75 14.5H6.75C6.33579 14.5 6 14.1642 6 13.75C6 13.3358 6.33579 13 6.75 13H14.75Z"
          fill="currentColor"
        />
        <path
          d="M7.75 6.5C8.44036 6.5 9 7.05964 9 7.75C9 8.44036 8.44036 9 7.75 9C7.05964 9 6.5 8.44036 6.5 7.75C6.5 7.05964 7.05964 6.5 7.75 6.5Z"
          fill="currentColor"
        />
        <path
          d="M13.75 6.5C14.4404 6.5 15 7.05964 15 7.75C15 8.44036 14.4404 9 13.75 9C13.0596 9 12.5 8.44036 12.5 7.75C12.5 7.05964 13.0596 6.5 13.75 6.5Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function FaceSadIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M10.75 12C12.2066 12 13.3586 12.5833 14.1289 13.1436C14.5154 13.4246 14.8136 13.7061 15.0176 13.9189C15.1197 14.0255 15.1994 14.1156 15.2549 14.1816C15.2825 14.2145 15.3045 14.2418 15.3203 14.2617C15.3282 14.2717 15.3349 14.2807 15.3398 14.2871C15.3422 14.2901 15.3441 14.2928 15.3457 14.2949L15.3496 14.2988L15.3926 14.3633C15.589 14.6888 15.5107 15.1165 15.2002 15.3496C14.8895 15.5826 14.4569 15.5384 14.1992 15.2588L14.1504 15.2012C14.1492 15.1997 14.1474 15.197 14.1445 15.1934C14.1372 15.1841 14.1245 15.168 14.1064 15.1465C14.0701 15.1032 14.0129 15.0368 13.9355 14.9561C13.7802 14.7939 13.547 14.5753 13.2461 14.3564C12.6414 13.9167 11.7932 13.5 10.75 13.5C9.70678 13.5 8.85856 13.9167 8.25391 14.3564C7.95302 14.5753 7.71985 14.7939 7.56445 14.9561C7.48708 15.0368 7.42989 15.1032 7.39355 15.1465C7.37554 15.168 7.3628 15.1841 7.35547 15.1934L7.34863 15.2012C7.09983 15.5313 6.63071 15.5978 6.2998 15.3496C5.9687 15.101 5.90194 14.6311 6.15039 14.2998L6.1543 14.2949C6.15593 14.2928 6.15783 14.2901 6.16016 14.2871C6.16506 14.2807 6.17177 14.2717 6.17969 14.2617C6.1955 14.2418 6.21751 14.2145 6.24512 14.1816C6.30056 14.1156 6.38027 14.0255 6.48242 13.9189C6.68636 13.7061 6.98462 13.4246 7.37109 13.1436C8.14142 12.5833 9.29335 12 10.75 12Z"
          fill="currentColor"
        />
        <path
          d="M5.26562 7.41699C5.58195 7.14959 6.05583 7.18954 6.32324 7.50586C6.61882 7.85539 6.94598 8 7.25 8C7.56161 8 7.89781 7.84952 8.16895 7.5166C8.4305 7.19556 8.9025 7.14677 9.22363 7.4082C9.54481 7.66978 9.59263 8.14269 9.33105 8.46387C8.81221 9.10073 8.06822 9.5 7.25 9.5C6.42411 9.5 5.70112 9.09488 5.17676 8.47461C4.90935 8.15828 4.9493 7.6844 5.26562 7.41699Z"
          fill="currentColor"
        />
        <path
          d="M12.2656 7.41699C12.582 7.14959 13.0558 7.18954 13.3232 7.50586C13.6188 7.85539 13.946 8 14.25 8C14.5616 8 14.8978 7.84952 15.1689 7.5166C15.4305 7.19556 15.9025 7.14677 16.2236 7.4082C16.5448 7.66978 16.5926 8.14269 16.3311 8.46387C15.8122 9.10073 15.0682 9.5 14.25 9.5C13.4241 9.5 12.7011 9.09488 12.1768 8.47461C11.9093 8.15828 11.9493 7.6844 12.2656 7.41699Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function FaceSmileIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M14.1992 12.2412C14.4569 11.9616 14.8895 11.9174 15.2002 12.1504C15.5107 12.3835 15.589 12.8112 15.3926 13.1367L15.3496 13.2002L15.3457 13.2051C15.3441 13.2072 15.3422 13.2099 15.3398 13.2129C15.3349 13.2193 15.3282 13.2283 15.3203 13.2383C15.3045 13.2582 15.2825 13.2855 15.2549 13.3184C15.1994 13.3844 15.1197 13.4745 15.0176 13.5811C14.8136 13.7939 14.5154 14.0754 14.1289 14.3564C13.3586 14.9167 12.2066 15.5 10.75 15.5C9.29335 15.5 8.14142 14.9167 7.37109 14.3564C6.98462 14.0754 6.68636 13.7939 6.48242 13.5811C6.38027 13.4745 6.30056 13.3844 6.24512 13.3184C6.21751 13.2855 6.1955 13.2582 6.17969 13.2383C6.17177 13.2283 6.16506 13.2193 6.16016 13.2129C6.15783 13.2099 6.15593 13.2072 6.1543 13.2051L6.15039 13.2012C5.90194 12.8699 5.9687 12.399 6.2998 12.1504C6.61049 11.9174 7.04315 11.9616 7.30078 12.2412L7.34863 12.2988C7.34954 12.3 7.35188 12.3021 7.35547 12.3066C7.3628 12.3159 7.37554 12.332 7.39355 12.3535C7.42989 12.3968 7.48708 12.4632 7.56445 12.5439C7.71985 12.7061 7.95302 12.9247 8.25391 13.1436C8.85856 13.5833 9.70678 14 10.75 14C11.7932 14 12.6414 13.5833 13.2461 13.1436C13.547 12.9247 13.7802 12.7061 13.9355 12.5439C14.0129 12.4632 14.0701 12.3968 14.1064 12.3535C14.1245 12.332 14.1372 12.3159 14.1445 12.3066L14.1504 12.2988L14.1992 12.2412Z"
          fill="currentColor"
        />
        <path
          d="M7.75 6.5C8.44036 6.5 9 7.05964 9 7.75C9 8.44036 8.44036 9 7.75 9C7.05964 9 6.5 8.44036 6.5 7.75C6.5 7.05964 7.05964 6.5 7.75 6.5Z"
          fill="currentColor"
        />
        <path
          d="M13.75 6.5C14.4404 6.5 15 7.05964 15 7.75C15 8.44036 14.4404 9 13.75 9C13.0596 9 12.5 8.44036 12.5 7.75C12.5 7.05964 13.0596 6.5 13.75 6.5Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function FaceWinkIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M14.1992 12.2412C14.4569 11.9616 14.8895 11.9174 15.2002 12.1504C15.5107 12.3835 15.589 12.8112 15.3926 13.1367L15.3496 13.2002L15.3457 13.2051C15.3441 13.2072 15.3422 13.2099 15.3398 13.2129C15.3349 13.2193 15.3282 13.2283 15.3203 13.2383C15.3045 13.2582 15.2825 13.2855 15.2549 13.3184C15.1994 13.3844 15.1197 13.4745 15.0176 13.5811C14.8136 13.7939 14.5154 14.0754 14.1289 14.3564C13.3586 14.9167 12.2066 15.5 10.75 15.5C9.29335 15.5 8.14142 14.9167 7.37109 14.3564C6.98462 14.0754 6.68636 13.7939 6.48242 13.5811C6.38027 13.4745 6.30056 13.3844 6.24512 13.3184C6.21751 13.2855 6.1955 13.2582 6.17969 13.2383C6.17177 13.2283 6.16506 13.2193 6.16016 13.2129C6.15783 13.2099 6.15593 13.2072 6.1543 13.2051L6.15039 13.2012C5.90194 12.8699 5.9687 12.399 6.2998 12.1504C6.61049 11.9174 7.04315 11.9616 7.30078 12.2412L7.34863 12.2988C7.34954 12.3 7.35188 12.3021 7.35547 12.3066C7.3628 12.3159 7.37554 12.332 7.39355 12.3535C7.42989 12.3968 7.48708 12.4632 7.56445 12.5439C7.71985 12.7061 7.95302 12.9247 8.25391 13.1436C8.85856 13.5833 9.70678 14 10.75 14C11.7932 14 12.6414 13.5833 13.2461 13.1436C13.547 12.9247 13.7802 12.7061 13.9355 12.5439C14.0129 12.4632 14.0701 12.3968 14.1064 12.3535C14.1245 12.332 14.1372 12.3159 14.1445 12.3066L14.1504 12.2988L14.1992 12.2412Z"
          fill="currentColor"
        />
        <path
          d="M13.75 6.5C14.4404 6.5 15 7.05964 15 7.75C15 8.44036 14.4404 9 13.75 9C13.0596 9 12.5 8.44036 12.5 7.75C12.5 7.05964 13.0596 6.5 13.75 6.5Z"
          fill="currentColor"
        />
        <path
          d="M8.75 7C9.16421 7 9.5 7.33579 9.5 7.75C9.5 8.16421 9.16421 8.5 8.75 8.5H6.75C6.33579 8.5 6 8.16421 6 7.75C6 7.33579 6.33579 7 6.75 7H8.75Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function User01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.25, 2.25)">
        <path
          d="M11.25 12.5C12.591 12.5 13.4279 12.4915 14.129 12.7041C15.6471 13.1646 16.8354 14.353 17.2959 15.8711C17.5086 16.5722 17.5 17.409 17.5 18.75C17.5 19.1642 17.1643 19.5 16.75 19.5C16.3359 19.5 16 19.1642 16 18.75C16 17.3 15.9922 16.7411 15.8604 16.3066C15.5453 15.2679 14.7321 14.4547 13.6934 14.1396C13.2589 14.0079 12.7 14 11.25 14H6.25005C4.80011 14 4.24116 14.0079 3.80669 14.1396C2.76801 14.4547 1.95478 15.268 1.6397 16.3066C1.50794 16.7411 1.50005 17.3 1.50005 18.75C1.50005 19.1642 1.16426 19.5 0.750047 19.5C0.335856 19.5 4.72899e-05 19.1642 4.72899e-05 18.75C4.72899e-05 17.4091 -0.00849794 16.5722 0.204149 15.8711C0.664658 14.353 1.85306 13.1646 3.37114 12.7041C4.07221 12.4915 4.90912 12.5 6.25005 12.5H11.25Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75005 0C11.6495 0 14 2.3505 14 5.25C14 8.1495 11.6495 10.5 8.75005 10.5C5.85057 10.5 3.50005 8.14948 3.50005 5.25C3.50005 2.35052 5.85057 2.5642e-05 8.75005 0ZM8.75005 1.5C6.679 1.50003 5.00005 3.17895 5.00005 5.25C5.00005 7.32105 6.679 8.99997 8.75005 9C10.8211 9 12.5 7.32107 12.5 5.25C12.5 3.17893 10.8211 1.5 8.75005 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function User02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.89, 2.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.1077 12C12.5259 12 15.5611 13.6521 17.4895 16.2041C17.6706 16.4437 17.8532 16.6822 17.9798 16.9082C18.1216 17.1615 18.2204 17.4428 18.2141 17.7822C18.2091 18.0537 18.1266 18.3148 18.0218 18.5254C17.9169 18.7359 17.7587 18.9594 17.5452 19.127C17.2613 19.3496 16.9479 19.4321 16.6507 19.4678C16.3736 19.5009 16.038 19.5 15.68 19.5H2.53445C2.17637 19.5 1.84084 19.501 1.56375 19.4678C1.26667 19.4321 0.95389 19.3495 0.670196 19.127C0.456761 18.9594 0.298442 18.7358 0.193634 18.5254C0.0888521 18.3148 0.00528155 18.0537 0.000274195 17.7822C-0.00593078 17.4428 0.0938053 17.1615 0.235626 16.9082C0.362141 16.6823 0.543918 16.4436 0.724884 16.2041C2.65323 13.652 5.6895 12.0001 9.1077 12ZM9.1077 13.5C6.18606 13.5001 3.58326 14.91 1.92215 17.1084C1.7172 17.3796 1.60917 17.5247 1.54422 17.6406C1.49472 17.729 1.50016 17.749 1.50027 17.7549C1.50083 17.7587 1.50274 17.7669 1.50613 17.7793C1.51215 17.8011 1.5223 17.8281 1.53641 17.8564C1.55054 17.8848 1.56556 17.9097 1.57938 17.9277C1.58704 17.9377 1.59322 17.9435 1.59598 17.9463L1.59695 17.9473C1.59695 17.9473 1.60195 17.9494 1.60965 17.9521C1.62796 17.9586 1.66713 17.9695 1.74246 17.9785C1.90972 17.9986 2.13989 18 2.53445 18H15.68C16.0747 18 16.3056 17.9985 16.4729 17.9785C16.5479 17.9695 16.5873 17.9586 16.6057 17.9521C16.6131 17.9496 16.6184 17.9473 16.6184 17.9473L16.6194 17.9463C16.6221 17.9436 16.6275 17.9374 16.635 17.9277C16.6489 17.9098 16.6648 17.8849 16.679 17.8564C16.6931 17.8281 16.7032 17.8012 16.7093 17.7793C16.7127 17.7667 16.7145 17.7585 16.7151 17.7549C16.7152 17.749 16.7208 17.7292 16.6712 17.6406C16.6062 17.5247 16.4982 17.3796 16.2932 17.1084C14.6321 14.9101 12.0293 13.5 9.1077 13.5Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.1077 0C12.0071 8.04034e-05 14.3577 2.35055 14.3577 5.25C14.3577 8.14945 12.0071 10.4999 9.1077 10.5C6.20838 10.4998 3.8577 8.14936 3.8577 5.25C3.8577 2.35064 6.20838 0.000214269 9.1077 0ZM9.1077 1.5C7.03681 1.50021 5.3577 3.17906 5.3577 5.25C5.3577 7.32094 7.03681 8.99979 9.1077 9C11.1787 8.99992 12.8577 7.32102 12.8577 5.25C12.8577 3.17898 11.1787 1.50008 9.1077 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function User03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M9.75008 13C13.4694 13 16.8327 14.6227 19.296 17.2354C19.5801 17.5367 19.5661 18.0118 19.2647 18.2959C18.9633 18.5799 18.4883 18.566 18.2042 18.2646C15.996 15.9226 13.0167 14.5 9.75008 14.5C6.48351 14.5 3.50418 15.9226 1.29598 18.2646C1.01183 18.5659 0.53679 18.58 0.235435 18.2959C-0.065827 18.0118 -0.079838 17.5367 0.204185 17.2354C2.66749 14.6227 6.03082 13 9.75008 13Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.75008 0C12.6496 0 15.0001 2.3505 15.0001 5.25C15.0001 8.1495 12.6496 10.5 9.75008 10.5C6.85066 10.4999 4.50008 8.14944 4.50008 5.25C4.50008 2.35056 6.85066 8.94227e-05 9.75008 0ZM9.75008 1.5C7.67909 1.50009 6.00008 3.17899 6.00008 5.25C6.00008 7.32101 7.67909 8.99991 9.75008 9C11.8212 9 13.5001 7.32107 13.5001 5.25C13.5001 3.17893 11.8212 1.5 9.75008 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserCheck01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M10.75 12.5C11.1643 12.5 11.5 12.8358 11.5 13.25C11.5 13.6642 11.1643 14 10.75 14H6.25005C4.80011 14 4.24116 14.0079 3.80669 14.1396C2.76801 14.4547 1.95478 15.268 1.6397 16.3066C1.50794 16.7411 1.50005 17.3 1.50005 18.75C1.50005 19.1642 1.16426 19.5 0.750047 19.5C0.335856 19.5 4.73066e-05 19.1642 4.73066e-05 18.75C4.72912e-05 17.4091 -0.00849882 16.5722 0.204149 15.8711C0.664658 14.353 1.85306 13.1646 3.37114 12.7041C4.07221 12.4915 4.90912 12.5 6.25005 12.5H10.75Z"
          fill="currentColor"
        />
        <path
          d="M20.2198 13.2197C20.5127 12.9268 20.9874 12.9269 21.2803 13.2197C21.5732 13.5126 21.5732 13.9874 21.2803 14.2803L17.2803 18.2803C16.9874 18.5731 16.5127 18.5732 16.2198 18.2803L14.2198 16.2803C13.9269 15.9874 13.9269 15.5126 14.2198 15.2197C14.5127 14.9268 14.9874 14.9269 15.2803 15.2197L16.75 16.6895L20.2198 13.2197Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75005 0C11.6495 0 14 2.3505 14 5.25C14 8.1495 11.6495 10.5 8.75005 10.5C5.85057 10.5 3.50005 8.14948 3.50005 5.25C3.50005 2.35052 5.85057 2.55776e-05 8.75005 0ZM8.75005 1.5C6.679 1.50003 5.00005 3.17895 5.00005 5.25C5.00005 7.32105 6.679 8.99997 8.75005 9C10.8211 9 12.5 7.32107 12.5 5.25C12.5 3.17893 10.8211 1.5 8.75005 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserCheck02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 3.25)">
        <path
          d="M9.9502 11C10.7778 11 11.4436 10.999 11.9814 11.043C12.5281 11.0876 13.008 11.1829 13.4522 11.4092C14.1578 11.7687 14.7313 12.3422 15.0908 13.0479C15.3171 13.4921 15.4124 13.9719 15.457 14.5186C15.501 15.0564 15.5 15.7222 15.5 16.5498V17.75C15.5 18.1642 15.1642 18.5 14.75 18.5C14.3358 18.5 14 18.1642 14 17.75V16.5498C14 15.6975 13.9997 15.1032 13.9619 14.6406C13.9248 14.1868 13.8555 13.926 13.7549 13.7285C13.5392 13.3052 13.1949 12.9608 12.7715 12.7451C12.574 12.6445 12.3132 12.5752 11.8594 12.5381C11.3968 12.5003 10.8025 12.5 9.9502 12.5H5.54981C4.69746 12.5 4.10322 12.5003 3.64063 12.5381C3.1868 12.5752 2.92602 12.6445 2.72852 12.7451C2.30515 12.9608 1.96083 13.3052 1.74512 13.7285C1.64449 13.926 1.57517 14.1868 1.53809 14.6406C1.50029 15.1032 1.5 15.6975 1.5 16.5498V17.75C1.5 18.1642 1.16422 18.5 0.750002 18.5C0.335789 18.5 1.7448e-06 18.1642 1.7448e-06 17.75V16.5498C1.65324e-06 15.7222 -0.000968203 15.0564 0.0429705 14.5186C0.0876302 13.9719 0.182866 13.4921 0.409181 13.0479C0.768706 12.3422 1.34225 11.7687 2.04785 11.4092C2.49205 11.1829 2.97195 11.0876 3.51856 11.043C4.05639 10.999 4.72222 11 5.54981 11H9.9502Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75 0C10.0972 0 12 1.90279 12 4.25C12 6.59721 10.0972 8.5 7.75 8.5C5.40279 8.5 3.5 6.59721 3.5 4.25C3.5 1.90279 5.40279 9.66398e-07 7.75 0ZM7.75 1.5C6.23122 1.5 5 2.73122 5 4.25C5 5.76878 6.23122 7 7.75 7C9.26879 7 10.5 5.76878 10.5 4.25C10.5 2.73122 9.26879 1.5 7.75 1.5Z"
          fill="currentColor"
        />
        <path
          d="M20.2197 0.219727C20.5126 -0.073166 20.9874 -0.0731654 21.2803 0.219727C21.5732 0.51262 21.5732 0.98738 21.2803 1.28027L17.2803 5.28027C16.9874 5.57317 16.5126 5.57317 16.2197 5.28027L14.2197 3.28027C13.9268 2.98738 13.9268 2.51262 14.2197 2.21973C14.5126 1.92683 14.9874 1.92683 15.2803 2.21973L16.75 3.68945L20.2197 0.219727Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserCircleIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 3.5C13.3734 3.5 15.5 5.62665 15.5 8.25C15.5 10.8734 13.3734 13 10.75 13C8.12665 13 6 10.8734 6 8.25C6 5.62665 8.12665 3.5 10.75 3.5ZM10.75 5C8.95507 5 7.5 6.45507 7.5 8.25C7.5 10.0449 8.95507 11.5 10.75 11.5C12.5449 11.5 14 10.0449 14 8.25C14 6.45507 12.5449 5 10.75 5Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM7.75 16.5C6.60019 16.5 5.58976 17.098 5.01172 18.001C6.58898 19.2509 8.58124 20 10.75 20C12.9185 20 14.9101 19.2506 16.4873 18.001C15.9092 17.0982 14.8996 16.5 13.75 16.5H7.75ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 13.1436 2.40958 15.3244 3.90137 16.9668C4.76393 15.776 6.16556 15 7.75 15H13.75C15.3342 15 16.7351 15.7763 17.5977 16.9668C19.0897 15.3243 20 13.1438 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserDown01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M10.75 12.5C11.1643 12.5 11.5 12.8358 11.5 13.25C11.5 13.6642 11.1643 14 10.75 14H6.25005C4.80011 14 4.24116 14.0079 3.80669 14.1396C2.76801 14.4547 1.95478 15.268 1.6397 16.3066C1.50794 16.7411 1.50005 17.3 1.50005 18.75C1.50005 19.1642 1.16426 19.5 0.750047 19.5C0.335856 19.5 4.73066e-05 19.1642 4.73066e-05 18.75C4.72912e-05 17.4091 -0.00849882 16.5722 0.204149 15.8711C0.664658 14.353 1.85306 13.1646 3.37114 12.7041C4.07221 12.4915 4.90912 12.5 6.25005 12.5H10.75Z"
          fill="currentColor"
        />
        <path
          d="M17.75 12C18.1643 12 18.5 12.3358 18.5 12.75V16.9395L20.2198 15.2197C20.5127 14.9268 20.9874 14.9269 21.2803 15.2197C21.5732 15.5126 21.5732 15.9874 21.2803 16.2803L18.2803 19.2803C17.9874 19.5731 17.5127 19.5732 17.2198 19.2803L14.2198 16.2803C13.9269 15.9874 13.9269 15.5126 14.2198 15.2197C14.5127 14.9268 14.9874 14.9269 15.2803 15.2197L17 16.9395V12.75C17 12.3358 17.3359 12 17.75 12Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75005 0C11.6495 0 14 2.3505 14 5.25C14 8.1495 11.6495 10.5 8.75005 10.5C5.85057 10.5 3.50005 8.14948 3.50005 5.25C3.50005 2.35052 5.85057 2.55776e-05 8.75005 0ZM8.75005 1.5C6.679 1.50003 5.00005 3.17895 5.00005 5.25C5.00005 7.32105 6.679 8.99997 8.75005 9C10.8211 9 12.5 7.32107 12.5 5.25C12.5 3.17893 10.8211 1.5 8.75005 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserDown02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 3.25)">
        <path
          d="M9.9502 11C10.7778 11 11.4436 10.999 11.9814 11.043C12.5281 11.0876 13.008 11.1829 13.4522 11.4092C14.1578 11.7687 14.7313 12.3422 15.0908 13.0479C15.3171 13.4921 15.4124 13.9719 15.457 14.5186C15.501 15.0564 15.5 15.7222 15.5 16.5498V17.75C15.5 18.1642 15.1642 18.5 14.75 18.5C14.3358 18.5 14 18.1642 14 17.75V16.5498C14 15.6975 13.9997 15.1032 13.9619 14.6406C13.9248 14.1868 13.8555 13.926 13.7549 13.7285C13.5392 13.3052 13.1949 12.9608 12.7715 12.7451C12.574 12.6445 12.3132 12.5752 11.8594 12.5381C11.3968 12.5003 10.8025 12.5 9.9502 12.5H5.54981C4.69746 12.5 4.10322 12.5003 3.64063 12.5381C3.1868 12.5752 2.92602 12.6445 2.72852 12.7451C2.30515 12.9608 1.96083 13.3052 1.74512 13.7285C1.64449 13.926 1.57517 14.1868 1.53809 14.6406C1.50029 15.1032 1.5 15.6975 1.5 16.5498V17.75C1.5 18.1642 1.16422 18.5 0.750002 18.5C0.335789 18.5 1.7448e-06 18.1642 1.7448e-06 17.75V16.5498C1.65324e-06 15.7222 -0.000968203 15.0564 0.0429705 14.5186C0.0876302 13.9719 0.182866 13.4921 0.409181 13.0479C0.768706 12.3422 1.34225 11.7687 2.04785 11.4092C2.49205 11.1829 2.97195 11.0876 3.51856 11.043C4.05639 10.999 4.72222 11 5.54981 11H9.9502Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75 0C10.0972 0 12 1.90279 12 4.25C12 6.59721 10.0972 8.5 7.75 8.5C5.40279 8.5 3.5 6.59721 3.5 4.25C3.5 1.90279 5.40279 9.66398e-07 7.75 0ZM7.75 1.5C6.23122 1.5 5 2.73122 5 4.25C5 5.76878 6.23122 7 7.75 7C9.26879 7 10.5 5.76878 10.5 4.25C10.5 2.73122 9.26879 1.5 7.75 1.5Z"
          fill="currentColor"
        />
        <path
          d="M17.75 0C18.1642 0 18.5 0.335786 18.5 0.75V4.93945L20.2197 3.21973C20.5126 2.92683 20.9874 2.92683 21.2803 3.21973C21.5732 3.51262 21.5732 3.98738 21.2803 4.28027L18.2803 7.28027C17.9874 7.57317 17.5126 7.57317 17.2197 7.28027L14.2197 4.28027C13.9268 3.98738 13.9268 3.51262 14.2197 3.21973C14.5126 2.92683 14.9874 2.92683 15.2803 3.21973L17 4.93945V0.75C17 0.335787 17.3358 9.66389e-07 17.75 0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserEditIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M7.75005 12.5C8.16426 12.5 8.50005 12.8358 8.50005 13.25C8.50005 13.6642 8.16426 14 7.75005 14H6.25005C4.80011 14 4.24116 14.0079 3.80669 14.1396C2.76801 14.4547 1.95478 15.268 1.6397 16.3066C1.50794 16.7411 1.50005 17.3 1.50005 18.75C1.50005 19.1642 1.16426 19.5 0.750047 19.5C0.335856 19.5 4.73066e-05 19.1642 4.73066e-05 18.75C4.72912e-05 17.4091 -0.00849882 16.5722 0.204149 15.8711C0.664658 14.353 1.85306 13.1646 3.37114 12.7041C4.07221 12.4915 4.90912 12.5 6.25005 12.5H7.75005Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9698 7.96973C17.953 6.98649 19.5471 6.98652 20.5303 7.96973C21.5136 8.95299 21.5136 10.547 20.5303 11.5303L14.0733 17.9873C13.9797 18.0809 13.8797 18.1839 13.7618 18.2705C13.6663 18.3405 13.5637 18.4008 13.4561 18.4502C13.3232 18.5112 13.1849 18.5486 13.0577 18.585L9.9561 19.4707C9.69422 19.5455 9.41236 19.4729 9.21977 19.2803C9.0272 19.0877 8.95453 18.8058 9.02934 18.5439L9.91509 15.4424C9.95142 15.3152 9.98886 15.1769 10.0499 15.0439C10.0992 14.9364 10.1595 14.8337 10.2295 14.7383C10.3161 14.6203 10.4191 14.5203 10.5127 14.4268L16.9698 7.96973ZM19.4698 9.03027C19.0723 8.63285 18.4278 8.63282 18.0303 9.03027L11.5733 15.4873C11.5159 15.5447 11.4844 15.5767 11.461 15.6016C11.4453 15.6182 11.4385 15.626 11.4385 15.626C11.4286 15.6396 11.4202 15.6546 11.4131 15.6699C11.4121 15.6724 11.4086 15.6806 11.4024 15.7002C11.392 15.7328 11.3798 15.7763 11.3575 15.8545L10.8409 17.6582L12.6456 17.1426C12.7237 17.1202 12.7673 17.108 12.7999 17.0977C12.8194 17.0914 12.8277 17.0879 12.8301 17.0869C12.8454 17.0799 12.8605 17.0715 12.8741 17.0615C12.8741 17.0615 12.8819 17.0547 12.8985 17.0391C12.9234 17.0156 12.9554 16.9841 13.0127 16.9268L19.4698 10.4697C19.8673 10.0722 19.8673 9.42774 19.4698 9.03027Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75005 0C11.6495 0 14 2.3505 14 5.25C14 8.1495 11.6495 10.5 8.75005 10.5C5.85057 10.5 3.50005 8.14948 3.50005 5.25C3.50005 2.35052 5.85057 2.55776e-05 8.75005 0ZM8.75005 1.5C6.679 1.50003 5.00005 3.17895 5.00005 5.25C5.00005 7.32105 6.679 8.99997 8.75005 9C10.8211 9 12.5 7.32107 12.5 5.25C12.5 3.17893 10.8211 1.5 8.75005 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserLeft01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M10.75 12.5C11.1643 12.5 11.5 12.8358 11.5 13.25C11.5 13.6642 11.1643 14 10.75 14H6.25005C4.80011 14 4.24116 14.0079 3.80669 14.1396C2.76801 14.4547 1.95478 15.268 1.6397 16.3066C1.50794 16.7411 1.50005 17.3 1.50005 18.75C1.50005 19.1642 1.16426 19.5 0.750047 19.5C0.335856 19.5 4.73066e-05 19.1642 4.73066e-05 18.75C4.72912e-05 17.4091 -0.00849882 16.5722 0.204149 15.8711C0.664658 14.353 1.85306 13.1646 3.37114 12.7041C4.07221 12.4915 4.90912 12.5 6.25005 12.5H10.75Z"
          fill="currentColor"
        />
        <path
          d="M17.2198 12.2197C17.5127 11.9268 17.9874 11.9269 18.2803 12.2197C18.5732 12.5126 18.5732 12.9874 18.2803 13.2803L16.5606 15H20.75C21.1643 15 21.5 15.3358 21.5 15.75C21.5 16.1642 21.1643 16.5 20.75 16.5H16.5606L18.2803 18.2197C18.5732 18.5126 18.5732 18.9874 18.2803 19.2803C17.9874 19.5731 17.5127 19.5732 17.2198 19.2803L14.2198 16.2803C13.9269 15.9874 13.9269 15.5126 14.2198 15.2197L17.2198 12.2197Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75005 0C11.6495 0 14 2.3505 14 5.25C14 8.1495 11.6495 10.5 8.75005 10.5C5.85057 10.5 3.50005 8.14948 3.50005 5.25C3.50005 2.35052 5.85057 2.55776e-05 8.75005 0ZM8.75005 1.5C6.679 1.50003 5.00005 3.17895 5.00005 5.25C5.00005 7.32105 6.679 8.99997 8.75005 9C10.8211 9 12.5 7.32107 12.5 5.25C12.5 3.17893 10.8211 1.5 8.75005 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserLeft02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M9.9502 11.9999C10.7778 11.9999 11.4436 11.999 11.9814 12.0429C12.5281 12.0876 13.008 12.1828 13.4522 12.4091C14.1577 12.7686 14.7313 13.3422 15.0908 14.0478C15.3171 14.492 15.4124 14.9719 15.457 15.5185C15.501 16.0563 15.5 16.7222 15.5 17.5497V18.7499C15.5 19.1641 15.1642 19.4999 14.75 19.4999C14.3358 19.4999 14 19.1641 14 18.7499V17.5497C14 16.6974 13.9997 16.1032 13.9619 15.6406C13.9248 15.1868 13.8555 14.926 13.7549 14.7285C13.5392 14.3051 13.1948 13.9608 12.7715 13.7451C12.574 13.6444 12.3132 13.5751 11.8594 13.538C11.3968 13.5002 10.8025 13.4999 9.9502 13.4999H5.54981C4.69746 13.4999 4.10322 13.5002 3.64063 13.538C3.18681 13.5751 2.92602 13.6444 2.72852 13.7451C2.30516 13.9608 1.96083 14.3051 1.74512 14.7285C1.64451 14.926 1.57517 15.1868 1.53809 15.6406C1.5003 16.1032 1.5 16.6974 1.5 17.5497V18.7499C1.49997 19.1641 1.1642 19.4999 0.750002 19.4999C0.335808 19.4999 3.25144e-05 19.1641 1.72079e-06 18.7499V17.5497C1.62967e-06 16.7222 -0.00096355 16.0563 0.0429705 15.5185C0.0876287 14.9719 0.182883 14.492 0.409181 14.0478C0.768703 13.3422 1.34226 12.7686 2.04785 12.4091C2.49205 12.1828 2.97195 12.0876 3.51856 12.0429C4.05639 11.999 4.72222 11.9999 5.54981 11.9999H9.9502Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75 0.999943C10.0972 0.999943 12 2.90273 12 5.24994C12 7.59713 10.0972 9.49994 7.75 9.49994C5.40281 9.49994 3.50003 7.59713 3.5 5.24994C3.5 2.90273 5.40279 0.999944 7.75 0.999943ZM7.75 2.49994C6.23122 2.49994 5 3.73116 5 5.24994C5.00003 6.7687 6.23124 7.99994 7.75 7.99994C9.26877 7.99994 10.5 6.7687 10.5 5.24994C10.5 3.73116 9.26879 2.49994 7.75 2.49994Z"
          fill="currentColor"
        />
        <path
          d="M17.2197 0.21967C17.5126 -0.0732232 17.9874 -0.0732232 18.2803 0.21967C18.5731 0.512565 18.5732 0.987332 18.2803 1.28022L16.5605 2.99994H20.75C21.1642 2.99994 21.5 3.33573 21.5 3.74994C21.5 4.16413 21.1642 4.49994 20.75 4.49994H16.5605L18.2803 6.21967C18.5731 6.51257 18.5732 6.98733 18.2803 7.28022C17.9874 7.57307 17.5126 7.57307 17.2197 7.28022L14.2197 4.28022C14.0791 4.13958 14 3.94883 14 3.74994C14 3.55104 14.0791 3.36032 14.2197 3.21967L17.2197 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserMinus01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M10.75 12.5C11.1643 12.5 11.5 12.8358 11.5 13.25C11.5 13.6642 11.1643 14 10.75 14H6.25005C4.80011 14 4.24116 14.0079 3.80669 14.1396C2.76801 14.4547 1.95478 15.268 1.6397 16.3066C1.50794 16.7411 1.50005 17.3 1.50005 18.75C1.50005 19.1642 1.16426 19.5 0.750047 19.5C0.335856 19.5 4.73066e-05 19.1642 4.73066e-05 18.75C4.72912e-05 17.4091 -0.00849882 16.5722 0.204149 15.8711C0.664658 14.353 1.85306 13.1646 3.37114 12.7041C4.07221 12.4915 4.90912 12.5 6.25005 12.5H10.75Z"
          fill="currentColor"
        />
        <path
          d="M20.75 15C21.1643 15 21.5 15.3358 21.5 15.75C21.5 16.1642 21.1643 16.5 20.75 16.5H14.75C14.3359 16.5 14 16.1642 14 15.75C14 15.3358 14.3359 15 14.75 15H20.75Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75005 0C11.6495 0 14 2.3505 14 5.25C14 8.1495 11.6495 10.5 8.75005 10.5C5.85057 10.5 3.50005 8.14948 3.50005 5.25C3.50005 2.35052 5.85057 2.55776e-05 8.75005 0ZM8.75005 1.5C6.679 1.50003 5.00005 3.17895 5.00005 5.25C5.00005 7.32105 6.679 8.99997 8.75005 9C10.8211 9 12.5 7.32107 12.5 5.25C12.5 3.17893 10.8211 1.5 8.75005 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserMinus02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 3.25)">
        <path
          d="M9.9502 11C10.7778 11 11.4436 10.999 11.9814 11.043C12.5281 11.0876 13.008 11.1829 13.4522 11.4092C14.1578 11.7687 14.7313 12.3422 15.0908 13.0479C15.3171 13.4921 15.4124 13.9719 15.457 14.5186C15.501 15.0564 15.5 15.7222 15.5 16.5498V17.75C15.5 18.1642 15.1642 18.5 14.75 18.5C14.3358 18.5 14 18.1642 14 17.75V16.5498C14 15.6975 13.9997 15.1032 13.9619 14.6406C13.9248 14.1868 13.8555 13.926 13.7549 13.7285C13.5392 13.3052 13.1949 12.9608 12.7715 12.7451C12.574 12.6445 12.3132 12.5752 11.8594 12.5381C11.3968 12.5003 10.8025 12.5 9.9502 12.5H5.54981C4.69746 12.5 4.10322 12.5003 3.64063 12.5381C3.1868 12.5752 2.92602 12.6445 2.72852 12.7451C2.30515 12.9608 1.96083 13.3052 1.74512 13.7285C1.64449 13.926 1.57517 14.1868 1.53809 14.6406C1.50029 15.1032 1.5 15.6975 1.5 16.5498V17.75C1.5 18.1642 1.16422 18.5 0.750002 18.5C0.335789 18.5 1.7448e-06 18.1642 1.7448e-06 17.75V16.5498C1.65324e-06 15.7222 -0.000968203 15.0564 0.0429705 14.5186C0.0876302 13.9719 0.182866 13.4921 0.409181 13.0479C0.768706 12.3422 1.34225 11.7687 2.04785 11.4092C2.49205 11.1829 2.97195 11.0876 3.51856 11.043C4.05639 10.999 4.72222 11 5.54981 11H9.9502Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75 0C10.0972 0 12 1.90279 12 4.25C12 6.59721 10.0972 8.5 7.75 8.5C5.40279 8.5 3.5 6.59721 3.5 4.25C3.5 1.90279 5.40279 9.66398e-07 7.75 0ZM7.75 1.5C6.23122 1.5 5 2.73122 5 4.25C5 5.76878 6.23122 7 7.75 7C9.26879 7 10.5 5.76878 10.5 4.25C10.5 2.73122 9.26879 1.5 7.75 1.5Z"
          fill="currentColor"
        />
        <path
          d="M20.75 3C21.1642 3 21.5 3.33579 21.5 3.75C21.5 4.16421 21.1642 4.5 20.75 4.5H14.75C14.3358 4.5 14 4.16421 14 3.75C14 3.33579 14.3358 3 14.75 3H20.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserPlus01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M10.75 12.5C11.1643 12.5 11.5 12.8358 11.5 13.25C11.5 13.6642 11.1643 14 10.75 14H6.25005C4.80011 14 4.24116 14.0079 3.80669 14.1396C2.76801 14.4547 1.95478 15.268 1.6397 16.3066C1.50794 16.7411 1.50005 17.3 1.50005 18.75C1.50005 19.1642 1.16426 19.5 0.750047 19.5C0.335856 19.5 4.73066e-05 19.1642 4.73066e-05 18.75C4.72912e-05 17.4091 -0.00849882 16.5722 0.204149 15.8711C0.664658 14.353 1.85306 13.1646 3.37114 12.7041C4.07221 12.4915 4.90912 12.5 6.25005 12.5H10.75Z"
          fill="currentColor"
        />
        <path
          d="M17.75 12C18.1643 12 18.5 12.3358 18.5 12.75V15H20.75C21.1643 15 21.5 15.3358 21.5 15.75C21.5 16.1642 21.1643 16.5 20.75 16.5H18.5V18.75C18.5 19.1642 18.1643 19.5 17.75 19.5C17.3359 19.5 17 19.1642 17 18.75V16.5H14.75C14.3359 16.5 14 16.1642 14 15.75C14 15.3358 14.3359 15 14.75 15H17V12.75C17 12.3358 17.3359 12 17.75 12Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75005 0C11.6495 0 14 2.3505 14 5.25C14 8.1495 11.6495 10.5 8.75005 10.5C5.85057 10.5 3.50005 8.14948 3.50005 5.25C3.50005 2.35052 5.85057 2.55776e-05 8.75005 0ZM8.75005 1.5C6.679 1.50003 5.00005 3.17895 5.00005 5.25C5.00005 7.32105 6.679 8.99997 8.75005 9C10.8211 9 12.5 7.32107 12.5 5.25C12.5 3.17893 10.8211 1.5 8.75005 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserPlus02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 3.25)">
        <path
          d="M9.9502 11C10.7778 11 11.4436 10.999 11.9814 11.043C12.5281 11.0876 13.008 11.1829 13.4522 11.4092C14.1578 11.7687 14.7313 12.3422 15.0908 13.0479C15.3171 13.4921 15.4124 13.9719 15.457 14.5186C15.501 15.0564 15.5 15.7222 15.5 16.5498V17.75C15.5 18.1642 15.1642 18.5 14.75 18.5C14.3358 18.5 14 18.1642 14 17.75V16.5498C14 15.6975 13.9997 15.1032 13.9619 14.6406C13.9248 14.1868 13.8555 13.926 13.7549 13.7285C13.5392 13.3052 13.1949 12.9608 12.7715 12.7451C12.574 12.6445 12.3132 12.5752 11.8594 12.5381C11.3968 12.5003 10.8025 12.5 9.9502 12.5H5.54981C4.69746 12.5 4.10322 12.5003 3.64063 12.5381C3.1868 12.5752 2.92602 12.6445 2.72852 12.7451C2.30515 12.9608 1.96083 13.3052 1.74512 13.7285C1.64449 13.926 1.57517 14.1868 1.53809 14.6406C1.50029 15.1032 1.5 15.6975 1.5 16.5498V17.75C1.5 18.1642 1.16422 18.5 0.750002 18.5C0.335789 18.5 1.7448e-06 18.1642 1.7448e-06 17.75V16.5498C1.65324e-06 15.7222 -0.000968203 15.0564 0.0429705 14.5186C0.0876302 13.9719 0.182866 13.4921 0.409181 13.0479C0.768706 12.3422 1.34225 11.7687 2.04785 11.4092C2.49205 11.1829 2.97195 11.0876 3.51856 11.043C4.05639 10.999 4.72222 11 5.54981 11H9.9502Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75 0C10.0972 0 12 1.90279 12 4.25C12 6.59721 10.0972 8.5 7.75 8.5C5.40279 8.5 3.5 6.59721 3.5 4.25C3.5 1.90279 5.40279 9.66398e-07 7.75 0ZM7.75 1.5C6.23122 1.5 5 2.73122 5 4.25C5 5.76878 6.23122 7 7.75 7C9.26879 7 10.5 5.76878 10.5 4.25C10.5 2.73122 9.26879 1.5 7.75 1.5Z"
          fill="currentColor"
        />
        <path
          d="M17.75 0C18.1642 0 18.5 0.335786 18.5 0.75V3H20.75C21.1642 3 21.5 3.33579 21.5 3.75C21.5 4.16421 21.1642 4.5 20.75 4.5H18.5V6.75C18.5 7.16421 18.1642 7.5 17.75 7.5C17.3358 7.5 17 7.16421 17 6.75V4.5H14.75C14.3358 4.5 14 4.16421 14 3.75C14 3.33579 14.3358 3 14.75 3H17V0.75C17 0.335787 17.3358 9.66389e-07 17.75 0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserRight01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M10.75 12.5C11.1643 12.5 11.5 12.8358 11.5 13.25C11.5 13.6642 11.1643 14 10.75 14H6.25005C4.80011 14 4.24116 14.0079 3.80669 14.1396C2.76801 14.4547 1.95478 15.268 1.6397 16.3066C1.50794 16.7411 1.50005 17.3 1.50005 18.75C1.50005 19.1642 1.16426 19.5 0.750047 19.5C0.335856 19.5 4.73066e-05 19.1642 4.73066e-05 18.75C4.72912e-05 17.4091 -0.00849882 16.5722 0.204149 15.8711C0.664658 14.353 1.85306 13.1646 3.37114 12.7041C4.07221 12.4915 4.90912 12.5 6.25005 12.5H10.75Z"
          fill="currentColor"
        />
        <path
          d="M17.2198 12.2197C17.5127 11.9268 17.9874 11.9269 18.2803 12.2197L21.2803 15.2197C21.5732 15.5126 21.5732 15.9874 21.2803 16.2803L18.2803 19.2803C17.9874 19.5731 17.5127 19.5732 17.2198 19.2803C16.9269 18.9874 16.9269 18.5126 17.2198 18.2197L18.9395 16.5H14.75C14.3359 16.5 14 16.1642 14 15.75C14 15.3358 14.3359 15 14.75 15H18.9395L17.2198 13.2803C16.9269 12.9874 16.9269 12.5126 17.2198 12.2197Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75005 0C11.6495 0 14 2.3505 14 5.25C14 8.1495 11.6495 10.5 8.75005 10.5C5.85057 10.5 3.50005 8.14948 3.50005 5.25C3.50005 2.35052 5.85057 2.55776e-05 8.75005 0ZM8.75005 1.5C6.679 1.50003 5.00005 3.17895 5.00005 5.25C5.00005 7.32105 6.679 8.99997 8.75005 9C10.8211 9 12.5 7.32107 12.5 5.25C12.5 3.17893 10.8211 1.5 8.75005 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserRight02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M9.9502 11.9999C10.7778 11.9999 11.4436 11.999 11.9814 12.0429C12.5281 12.0876 13.008 12.1828 13.4522 12.4091C14.1577 12.7686 14.7313 13.3422 15.0908 14.0478C15.3171 14.492 15.4124 14.9719 15.457 15.5185C15.501 16.0563 15.5 16.7222 15.5 17.5497V18.7499C15.5 19.1641 15.1642 19.4999 14.75 19.4999C14.3358 19.4999 14 19.1641 14 18.7499V17.5497C14 16.6974 13.9997 16.1032 13.9619 15.6406C13.9248 15.1868 13.8555 14.926 13.7549 14.7285C13.5392 14.3051 13.1948 13.9608 12.7715 13.7451C12.574 13.6444 12.3132 13.5751 11.8594 13.538C11.3968 13.5002 10.8025 13.4999 9.9502 13.4999H5.54981C4.69746 13.4999 4.10322 13.5002 3.64063 13.538C3.18681 13.5751 2.92602 13.6444 2.72852 13.7451C2.30516 13.9608 1.96083 14.3051 1.74512 14.7285C1.64451 14.926 1.57517 15.1868 1.53809 15.6406C1.5003 16.1032 1.5 16.6974 1.5 17.5497V18.7499C1.49997 19.1641 1.1642 19.4999 0.750002 19.4999C0.335808 19.4999 3.25144e-05 19.1641 1.72079e-06 18.7499V17.5497C1.62967e-06 16.7222 -0.00096355 16.0563 0.0429705 15.5185C0.0876287 14.9719 0.182883 14.492 0.409181 14.0478C0.768703 13.3422 1.34226 12.7686 2.04785 12.4091C2.49205 12.1828 2.97195 12.0876 3.51856 12.0429C4.05639 11.999 4.72222 11.9999 5.54981 11.9999H9.9502Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75 0.999943C10.0972 0.999943 12 2.90273 12 5.24994C12 7.59713 10.0972 9.49994 7.75 9.49994C5.40281 9.49994 3.50003 7.59713 3.5 5.24994C3.5 2.90273 5.40279 0.999944 7.75 0.999943ZM7.75 2.49994C6.23122 2.49994 5 3.73116 5 5.24994C5.00003 6.7687 6.23124 7.99994 7.75 7.99994C9.26877 7.99994 10.5 6.7687 10.5 5.24994C10.5 3.73116 9.26879 2.49994 7.75 2.49994Z"
          fill="currentColor"
        />
        <path
          d="M17.2197 0.21967C17.5126 -0.0732232 17.9874 -0.0732232 18.2803 0.21967L21.2803 3.21967C21.4209 3.36032 21.5 3.55104 21.5 3.74994C21.5 3.94883 21.4209 4.13958 21.2803 4.28022L18.2803 7.28022C17.9874 7.57307 17.5126 7.57307 17.2197 7.28022C16.9268 6.98733 16.9269 6.51257 17.2197 6.21967L18.9395 4.49994H14.75C14.3358 4.49994 14 4.16413 14 3.74994C14 3.33573 14.3358 2.99994 14.75 2.99994H18.9395L17.2197 1.28022C16.9268 0.987333 16.9269 0.512565 17.2197 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Users01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M9.75 12C10.6714 12 11.4001 11.9999 11.9893 12.04C12.5851 12.0807 13.0933 12.165 13.5674 12.3613C14.7313 12.8434 15.6566 13.7687 16.1387 14.9326C16.335 15.4067 16.4193 15.9149 16.46 16.5107C16.5001 17.1 16.5 17.8286 16.5 18.75C16.5 19.1642 16.1642 19.5 15.75 19.5C15.3358 19.5 15 19.1642 15 18.75C15 17.8079 14.9998 17.1387 14.9639 16.6123C14.9284 16.0927 14.861 15.7668 14.7529 15.5059C14.4231 14.7097 13.7903 14.0769 12.9941 13.7471C12.7332 13.639 12.4073 13.5716 11.8877 13.5361C11.3613 13.5002 10.6921 13.5 9.75 13.5H6.75C5.80786 13.5 5.13868 13.5002 4.6123 13.5361C4.09273 13.5716 3.76676 13.639 3.50586 13.7471C2.70971 14.0769 2.07692 14.7097 1.74707 15.5059C1.639 15.7668 1.57159 16.0927 1.53613 16.6123C1.50022 17.1387 1.5 17.8079 1.5 18.75C1.5 19.1642 1.16421 19.5 0.75 19.5C0.335786 19.5 6.62728e-09 19.1642 6.62728e-09 18.75C6.62728e-09 17.8286 -0.000139445 17.1 0.0400391 16.5107C0.0806934 15.9149 0.165042 15.4067 0.361328 14.9326C0.843424 13.7687 1.76873 12.8434 2.93262 12.3613C3.40666 12.165 3.91489 12.0807 4.51074 12.04C5.09995 11.9999 5.82859 12 6.75 12H9.75Z"
          fill="currentColor"
        />
        <path
          d="M17.0234 12.6895C17.1266 12.2885 17.5355 12.0465 17.9365 12.1494C19.9851 12.6767 21.5 14.5357 21.5 16.75V18.75C21.5 19.1642 21.1642 19.5 20.75 19.5C20.3358 19.5 20 19.1642 20 18.75V16.75C20 15.2368 18.9652 13.9635 17.5635 13.6025C17.1625 13.4993 16.9205 13.0905 17.0234 12.6895Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.25 0C10.8734 0 13 2.12665 13 4.75C13 7.37335 10.8734 9.5 8.25 9.5C5.62665 9.5 3.5 7.37335 3.5 4.75C3.5 2.12665 5.62665 0 8.25 0ZM8.25 1.5C6.45507 1.5 5 2.95507 5 4.75C5 6.54493 6.45507 8 8.25 8C10.0449 8 11.5 6.54493 11.5 4.75C11.5 2.95507 10.0449 1.5 8.25 1.5Z"
          fill="currentColor"
        />
        <path
          d="M13.5547 0.759766C13.7101 0.375844 14.1473 0.190347 14.5313 0.345703C16.2706 1.04979 17.5 2.75538 17.5 4.75C17.5 6.74462 16.2706 8.45021 14.5313 9.1543C14.1473 9.30965 13.7101 9.12416 13.5547 8.74023C13.3996 8.35638 13.5849 7.91904 13.9688 7.76367C15.161 7.28092 16 6.11265 16 4.75C16 3.38735 15.161 2.21908 13.9688 1.73633C13.5849 1.58096 13.3996 1.14362 13.5547 0.759766Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Users02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M8.24975 13C11.4395 13.0001 14.2842 14.6711 16.3396 17.2871C16.595 17.6127 16.5381 18.084 16.2126 18.3398C15.887 18.5954 15.4157 18.5384 15.1599 18.2129C13.3225 15.8744 10.8813 14.5001 8.24975 14.5C5.61814 14.5 3.17707 15.8744 1.33959 18.2129C1.08382 18.5384 0.61255 18.5953 0.28686 18.3398C-0.0387351 18.084 -0.0956952 17.6128 0.159907 17.2871C2.21536 14.6711 5.05994 13 8.24975 13Z"
          fill="currentColor"
        />
        <path
          d="M16.0662 14.207C16.237 13.8297 16.682 13.6623 17.0593 13.833C18.6954 14.5735 20.1487 15.7713 21.3396 17.2871C21.595 17.6127 21.5381 18.084 21.2126 18.3398C20.887 18.5954 20.4157 18.5384 20.1599 18.2129C19.0961 16.859 17.8266 15.8266 16.4402 15.1992C16.0631 15.0283 15.8955 14.5842 16.0662 14.207Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.24975 0C11.1491 0.000134902 13.4998 2.35059 13.4998 5.25C13.4998 8.14941 11.1491 10.4999 8.24975 10.5C5.35026 10.5 2.99975 8.1495 2.99975 5.25C2.99975 2.3505 5.35026 0 8.24975 0ZM8.24975 1.5C6.17868 1.5 4.49975 3.17893 4.49975 5.25C4.49975 7.32107 6.17868 9 8.24975 9C10.3207 8.99987 11.9998 7.32098 11.9998 5.25C11.9998 3.17902 10.3207 1.50013 8.24975 1.5Z"
          fill="currentColor"
        />
        <path
          d="M14.0779 0.883789C14.2623 0.512972 14.7129 0.361587 15.0837 0.545898C16.8104 1.40412 17.9998 3.18767 17.9998 5.25C17.9998 7.31232 16.8104 9.09588 15.0837 9.9541C14.7129 10.1384 14.2623 9.98703 14.0779 9.61621C13.8935 9.2453 14.0449 8.79471 14.4158 8.61035C15.6522 7.99578 16.4998 6.72121 16.4998 5.25C16.4998 3.77879 15.6522 2.50422 14.4158 1.88965C14.0449 1.70529 13.8935 1.2547 14.0779 0.883789Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Users03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.3, 2.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.19625 12C11.3147 12.0001 14.0493 13.703 15.7607 16.2725C15.9246 16.5186 16.0895 16.7626 16.2011 16.9902C16.3256 17.2442 16.4094 17.5236 16.3896 17.8545C16.3738 18.1177 16.2854 18.3683 16.1767 18.5713C16.0681 18.7742 15.9085 18.9864 15.6982 19.1455C15.4178 19.3575 15.1118 19.436 14.8222 19.4697C14.5515 19.5012 14.2242 19.5 13.874 19.5H2.51852C2.1683 19.5 1.84104 19.5012 1.57027 19.4697C1.28066 19.436 0.974692 19.3576 0.694298 19.1455C0.483935 18.9864 0.324455 18.7742 0.215783 18.5713C0.107123 18.3683 0.0186957 18.1178 0.00289219 17.8545C-0.016895 17.5236 0.0669042 17.2442 0.191369 16.9902C0.302952 16.7626 0.466911 16.5186 0.630822 16.2725C2.34225 13.7028 5.07767 12.0001 8.19625 12ZM8.19625 13.5C5.6537 13.5001 3.35698 14.8866 1.87985 17.1045C1.6946 17.3826 1.59604 17.5321 1.53805 17.6504C1.49444 17.7394 1.49943 17.7601 1.49996 17.7646C1.49968 17.7603 1.50026 17.769 1.5068 17.79C1.5133 17.8109 1.52375 17.8366 1.53805 17.8633C1.55225 17.8898 1.56731 17.9127 1.58102 17.9297C1.5896 17.9403 1.59601 17.9468 1.5986 17.9492C1.59964 17.9497 1.60464 17.9525 1.61227 17.9551C1.63085 17.9613 1.66966 17.9709 1.74313 17.9795C1.90728 17.9986 2.13276 18 2.51852 18H13.874C14.2593 18 14.4843 17.9985 14.6484 17.9795C14.7224 17.9709 14.7617 17.9614 14.7802 17.9551C14.7883 17.9523 14.7921 17.9497 14.7929 17.9492C14.7952 17.9471 14.8015 17.9408 14.8105 17.9297C14.8243 17.9127 14.8402 17.89 14.8545 17.8633C14.8687 17.8366 14.8792 17.8109 14.8857 17.79C14.89 17.7763 14.8911 17.7676 14.8916 17.7646C14.892 17.7602 14.8975 17.7401 14.8535 17.6504C14.7955 17.5321 14.6978 17.3825 14.5127 17.1045C13.0355 14.8867 10.7388 13.5001 8.19625 13.5Z"
          fill="currentColor"
        />
        <path
          d="M16.0263 13.25C16.2124 12.8802 16.6632 12.7312 17.0332 12.917C18.6227 13.7156 19.9706 14.9897 20.9482 16.5645C21.1069 16.8201 21.2953 17.101 21.3545 17.4824C21.4172 17.888 21.3074 18.2839 21.1367 18.5908C20.9659 18.8978 20.6872 19.1998 20.3095 19.3604C19.9488 19.5136 19.5543 19.5 19.1963 19.5C18.7821 19.4999 18.4463 19.1642 18.4463 18.75C18.4463 18.3358 18.7821 18.0001 19.1963 18C19.4177 18 19.5424 17.9994 19.6357 17.9922C19.6769 17.989 19.7001 17.9849 19.7119 17.9824C19.7171 17.9813 19.7204 17.9808 19.7216 17.9805C19.7216 17.9804 19.7355 17.9737 19.7568 17.9531C19.7794 17.9312 19.8049 17.8996 19.8261 17.8613C19.8473 17.8232 19.8605 17.7856 19.8671 17.7549C19.8728 17.7286 19.8722 17.7144 19.872 17.7119C19.8707 17.7034 19.8694 17.6909 19.8476 17.6475C19.8173 17.5871 19.7703 17.5109 19.6738 17.3555C18.8293 15.9951 17.6813 14.9209 16.3593 14.2568C15.9894 14.0708 15.8405 13.62 16.0263 13.25Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.19625 0C11.0957 8.83919e-05 13.4463 2.35056 13.4463 5.25C13.4463 8.14944 11.0957 10.4999 8.19625 10.5C5.29682 10.4999 2.94625 8.14945 2.94625 5.25C2.94625 2.35055 5.29682 7.85351e-05 8.19625 0ZM8.19625 1.5C6.12525 1.50008 4.44625 3.17898 4.44625 5.25C4.44625 7.32102 6.12525 8.99992 8.19625 9C10.2672 8.99991 11.9463 7.32101 11.9463 5.25C11.9463 3.17899 10.2672 1.50009 8.19625 1.5Z"
          fill="currentColor"
        />
        <path
          d="M14.0244 0.883789C14.2087 0.512986 14.6594 0.361671 15.0302 0.545898C16.757 1.40411 17.9463 3.18765 17.9463 5.25C17.9463 7.31235 16.757 9.09589 15.0302 9.9541C14.6594 10.1383 14.2087 9.98701 14.0244 9.61621C13.8401 9.24533 13.9914 8.79472 14.3623 8.61035C15.5988 7.99581 16.4463 6.72126 16.4463 5.25C16.4463 3.77874 15.5988 2.50419 14.3623 1.88965C13.9914 1.70528 13.8401 1.25467 14.0244 0.883789Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UsersCharacterIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25 21C1.25 20.0786 1.24986 19.35 1.29004 18.7607C1.33069 18.1649 1.41504 17.6567 1.61133 17.1826C2.09342 16.0187 3.01873 15.0934 4.18262 14.6113C4.65666 14.415 5.16489 14.3307 5.76074 14.29C6.34995 14.2499 7.07859 14.25 8 14.25H12C12.4142 14.25 12.75 14.5858 12.75 15C12.75 15.4142 12.4142 15.75 12 15.75H8C7.05786 15.75 6.38868 15.7502 5.8623 15.7861C5.34273 15.8216 5.01676 15.889 4.75586 15.9971C3.95971 16.3269 3.32692 16.9597 2.99707 17.7559C2.889 18.0168 2.82159 18.3427 2.78613 18.8623C2.75022 19.3887 2.75 20.0579 2.75 21C2.75 21.4142 2.41421 21.75 2 21.75C1.58579 21.75 1.25 21.4142 1.25 21ZM21.25 16.5996C21.25 16.3074 21.2498 16.133 21.2393 16.0039C21.2294 15.8838 21.2143 15.8703 21.2227 15.8867C21.1987 15.8397 21.1603 15.8013 21.1133 15.7773C21.1297 15.7857 21.1162 15.7706 20.9961 15.7607C20.867 15.7502 20.6926 15.75 20.4004 15.75H17.5996C17.3074 15.75 17.133 15.7502 17.0039 15.7607C16.8838 15.7706 16.8703 15.7857 16.8867 15.7773C16.8397 15.8013 16.8013 15.8397 16.7773 15.8867C16.7857 15.8703 16.7706 15.8838 16.7607 16.0039C16.7502 16.133 16.75 16.3074 16.75 16.5996V19.4004C16.75 19.6926 16.7502 19.867 16.7607 19.9961C16.7706 20.1162 16.7857 20.1297 16.7773 20.1133C16.8013 20.1603 16.8397 20.1987 16.8867 20.2227C16.8703 20.2143 16.8838 20.2294 17.0039 20.2393C17.133 20.2498 17.3074 20.25 17.5996 20.25H20.4004C20.6926 20.25 20.867 20.2498 20.9961 20.2393C21.1162 20.2294 21.1297 20.2143 21.1133 20.2227C21.1603 20.1987 21.1987 20.1603 21.2227 20.1133C21.2143 20.1297 21.2294 20.1162 21.2393 19.9961C21.2498 19.867 21.25 19.6926 21.25 19.4004V16.5996ZM12.75 7C12.75 5.20507 11.2949 3.75 9.5 3.75C7.70507 3.75 6.25 5.20507 6.25 7C6.25 8.79493 7.70507 10.25 9.5 10.25C11.2949 10.25 12.75 8.79493 12.75 7ZM17.25 7C17.25 5.63735 16.411 4.46908 15.2188 3.98633C14.8349 3.83096 14.6496 3.39362 14.8047 3.00977C14.9601 2.62584 15.3973 2.44035 15.7812 2.5957C17.5206 3.29979 18.75 5.00538 18.75 7C18.75 8.99462 17.5206 10.7002 15.7812 11.4043C15.3973 11.5597 14.9601 11.3742 14.8047 10.9902C14.6496 10.6064 14.8349 10.169 15.2188 10.0137C16.411 9.53092 17.25 8.36265 17.25 7ZM22.75 19.4004C22.75 19.6679 22.7501 19.9139 22.7334 20.1182C22.716 20.3312 22.6769 20.5647 22.5596 20.7949C22.3918 21.124 22.124 21.3918 21.7949 21.5596C21.5647 21.6769 21.3312 21.716 21.1182 21.7334C20.9139 21.7501 20.6679 21.75 20.4004 21.75H17.5996C17.3321 21.75 17.0861 21.7501 16.8818 21.7334C16.6688 21.716 16.4353 21.6769 16.2051 21.5596C15.876 21.3918 15.6082 21.124 15.4404 20.7949C15.3231 20.5647 15.284 20.3312 15.2666 20.1182C15.2499 19.9139 15.25 19.6679 15.25 19.4004V16.5996C15.25 16.3321 15.2499 16.0861 15.2666 15.8818C15.284 15.6688 15.3231 15.4353 15.4404 15.2051C15.6082 14.876 15.876 14.6082 16.2051 14.4404C16.4353 14.3231 16.6688 14.284 16.8818 14.2666C17.0861 14.2499 17.3321 14.25 17.5996 14.25H20.4004C20.6679 14.25 20.9139 14.2499 21.1182 14.2666C21.3312 14.284 21.5647 14.3231 21.7949 14.4404C22.124 14.6082 22.3918 14.876 22.5596 15.2051C22.6769 15.4353 22.716 15.6688 22.7334 15.8818C22.7501 16.0861 22.75 16.3321 22.75 16.5996V19.4004ZM14.25 7C14.25 9.62335 12.1234 11.75 9.5 11.75C6.87665 11.75 4.75 9.62335 4.75 7C4.75 4.37665 6.87665 2.25 9.5 2.25C12.1234 2.25 14.25 4.37665 14.25 7Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function UsersCheckIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M10.75 12C11.1642 12 11.5 12.3358 11.5 12.75C11.5 13.1642 11.1642 13.5 10.75 13.5H6.75C5.80786 13.5 5.13868 13.5002 4.6123 13.5361C4.09273 13.5716 3.76676 13.639 3.50586 13.7471C2.70971 14.0769 2.07692 14.7097 1.74707 15.5059C1.639 15.7668 1.57159 16.0927 1.53613 16.6123C1.50022 17.1387 1.5 17.8079 1.5 18.75C1.5 19.1642 1.16421 19.5 0.75 19.5C0.335786 19.5 6.62728e-09 19.1642 6.62728e-09 18.75C6.62728e-09 17.8286 -0.000139445 17.1 0.0400391 16.5107C0.0806934 15.9149 0.165042 15.4067 0.361328 14.9326C0.843424 13.7687 1.76873 12.8434 2.93262 12.3613C3.40666 12.165 3.91489 12.0807 4.51074 12.04C5.09995 11.9999 5.82859 12 6.75 12H10.75Z"
          fill="currentColor"
        />
        <path
          d="M20.2197 13.2197C20.5126 12.9268 20.9874 12.9268 21.2803 13.2197C21.5732 13.5126 21.5732 13.9874 21.2803 14.2803L17.2803 18.2803C16.9874 18.5732 16.5126 18.5732 16.2197 18.2803L14.2197 16.2803C13.9268 15.9874 13.9268 15.5126 14.2197 15.2197C14.5126 14.9268 14.9874 14.9268 15.2803 15.2197L16.75 16.6895L20.2197 13.2197Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.25 0C10.8734 0 13 2.12665 13 4.75C13 7.37335 10.8734 9.5 8.25 9.5C5.62665 9.5 3.5 7.37335 3.5 4.75C3.5 2.12665 5.62665 0 8.25 0ZM8.25 1.5C6.45507 1.5 5 2.95507 5 4.75C5 6.54493 6.45507 8 8.25 8C10.0449 8 11.5 6.54493 11.5 4.75C11.5 2.95507 10.0449 1.5 8.25 1.5Z"
          fill="currentColor"
        />
        <path
          d="M13.5547 0.759766C13.7101 0.375844 14.1473 0.190347 14.5313 0.345703C16.2706 1.04979 17.5 2.75538 17.5 4.75C17.5 6.74462 16.2706 8.45021 14.5313 9.1543C14.1473 9.30965 13.7101 9.12416 13.5547 8.74023C13.3996 8.35638 13.5849 7.91904 13.9688 7.76367C15.161 7.28092 16 6.11265 16 4.75C16 3.38735 15.161 2.21908 13.9688 1.73633C13.5849 1.58096 13.3996 1.14362 13.5547 0.759766Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UsersDownIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M10.75 12C11.1642 12 11.5 12.3358 11.5 12.75C11.5 13.1642 11.1642 13.5 10.75 13.5H6.75C5.80786 13.5 5.13868 13.5002 4.6123 13.5361C4.09273 13.5716 3.76676 13.639 3.50586 13.7471C2.70971 14.0769 2.07692 14.7097 1.74707 15.5059C1.639 15.7668 1.57159 16.0927 1.53613 16.6123C1.50022 17.1387 1.5 17.8079 1.5 18.75C1.5 19.1642 1.16421 19.5 0.75 19.5C0.335786 19.5 6.62728e-09 19.1642 6.62728e-09 18.75C6.62728e-09 17.8286 -0.000139445 17.1 0.0400391 16.5107C0.0806934 15.9149 0.165042 15.4067 0.361328 14.9326C0.843424 13.7687 1.76873 12.8434 2.93262 12.3613C3.40666 12.165 3.91489 12.0807 4.51074 12.04C5.09995 11.9999 5.82859 12 6.75 12H10.75Z"
          fill="currentColor"
        />
        <path
          d="M17.75 12C18.1642 12 18.5 12.3358 18.5 12.75V16.9395L20.2197 15.2197C20.5126 14.9268 20.9874 14.9268 21.2803 15.2197C21.5732 15.5126 21.5732 15.9874 21.2803 16.2803L18.2803 19.2803C17.9874 19.5732 17.5126 19.5732 17.2197 19.2803L14.2197 16.2803C13.9268 15.9874 13.9268 15.5126 14.2197 15.2197C14.5126 14.9268 14.9874 14.9268 15.2803 15.2197L17 16.9395V12.75C17 12.3358 17.3358 12 17.75 12Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.25 0C10.8734 0 13 2.12665 13 4.75C13 7.37335 10.8734 9.5 8.25 9.5C5.62665 9.5 3.5 7.37335 3.5 4.75C3.5 2.12665 5.62665 0 8.25 0ZM8.25 1.5C6.45507 1.5 5 2.95507 5 4.75C5 6.54493 6.45507 8 8.25 8C10.0449 8 11.5 6.54493 11.5 4.75C11.5 2.95507 10.0449 1.5 8.25 1.5Z"
          fill="currentColor"
        />
        <path
          d="M13.5547 0.759766C13.7101 0.375844 14.1473 0.190347 14.5312 0.345703C16.2706 1.04979 17.5 2.75538 17.5 4.75C17.5 6.74462 16.2706 8.45021 14.5312 9.1543C14.1473 9.30965 13.7101 9.12416 13.5547 8.74023C13.3996 8.35638 13.5849 7.91904 13.9687 7.76367C15.161 7.28092 16 6.11265 16 4.75C16 3.38735 15.161 2.21908 13.9687 1.73633C13.5849 1.58096 13.3996 1.14362 13.5547 0.759766Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UsersEditIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.7197 9.21973C18.5649 8.37455 19.9351 8.37457 20.7803 9.21973C21.6255 10.0649 21.6255 11.4351 20.7803 12.2803L14.123 18.9375C14.014 19.0466 13.8973 19.1674 13.7578 19.2646C13.6453 19.3431 13.5232 19.4079 13.3955 19.458C13.2374 19.52 13.073 19.5499 12.9219 19.5801L10.8965 19.9854C10.6508 20.0343 10.3969 19.9574 10.2197 19.7803C10.0424 19.6029 9.96546 19.3484 10.0146 19.1025L10.4199 17.0781C10.4502 16.9269 10.4799 16.7618 10.542 16.6035C10.5921 16.4759 10.657 16.3546 10.7354 16.2422C10.8326 16.1028 10.9534 15.986 11.0625 15.877L17.7197 9.21973ZM19.7197 10.2803C19.4603 10.0209 19.0397 10.0209 18.7803 10.2803L12.123 16.9375C12.0559 17.0046 12.0185 17.0421 11.9912 17.0713C11.9742 17.0895 11.9675 17.0974 11.9658 17.0996C11.9547 17.1156 11.9456 17.1332 11.9385 17.1514C11.9385 17.1514 11.9349 17.1625 11.9287 17.1885C11.9195 17.2273 11.9092 17.279 11.8906 17.3721L11.7061 18.293L12.6279 18.1094C12.721 18.0908 12.7726 18.0805 12.8115 18.0713C12.8374 18.0652 12.8486 18.0615 12.8486 18.0615C12.8668 18.0544 12.8844 18.0453 12.9004 18.0342C12.9025 18.0325 12.9104 18.0258 12.9287 18.0088C12.9579 17.9815 12.9954 17.9441 13.0625 17.877L19.7197 11.2197C19.9791 10.9603 19.9791 10.5397 19.7197 10.2803Z"
          fill="currentColor"
        />
        <path
          d="M9.75 12C10.1642 12 10.5 12.3358 10.5 12.75C10.5 13.1642 10.1642 13.5 9.75 13.5H6.75C5.80786 13.5 5.13868 13.5002 4.6123 13.5361C4.09273 13.5716 3.76676 13.639 3.50586 13.7471C2.70971 14.0769 2.07692 14.7097 1.74707 15.5059C1.639 15.7668 1.57159 16.0927 1.53613 16.6123C1.50022 17.1387 1.5 17.8079 1.5 18.75C1.5 19.1642 1.16421 19.5 0.75 19.5C0.335786 19.5 6.62728e-09 19.1642 6.62728e-09 18.75C6.62728e-09 17.8286 -0.000139445 17.1 0.0400391 16.5107C0.0806934 15.9149 0.165042 15.4067 0.361328 14.9326C0.843424 13.7687 1.76873 12.8434 2.93262 12.3613C3.40666 12.165 3.91489 12.0807 4.51074 12.04C5.09995 11.9999 5.82859 12 6.75 12H9.75Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.25 0C10.8734 0 13 2.12665 13 4.75C13 7.37335 10.8734 9.5 8.25 9.5C5.62665 9.5 3.5 7.37335 3.5 4.75C3.5 2.12665 5.62665 0 8.25 0ZM8.25 1.5C6.45507 1.5 5 2.95507 5 4.75C5 6.54493 6.45507 8 8.25 8C10.0449 8 11.5 6.54493 11.5 4.75C11.5 2.95507 10.0449 1.5 8.25 1.5Z"
          fill="currentColor"
        />
        <path
          d="M13.5547 0.759766C13.7101 0.375844 14.1473 0.190347 14.5312 0.345703C16.2706 1.04979 17.5 2.75538 17.5 4.75C17.5 5.16421 17.1642 5.5 16.75 5.5C16.3358 5.5 16 5.16421 16 4.75C16 3.38735 15.161 2.21908 13.9687 1.73633C13.5849 1.58096 13.3996 1.14362 13.5547 0.759766Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UsersLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M10.75 12C11.1642 12 11.5 12.3358 11.5 12.75C11.5 13.1642 11.1642 13.5 10.75 13.5H6.75C5.80786 13.5 5.13868 13.5002 4.6123 13.5361C4.09273 13.5716 3.76676 13.639 3.50586 13.7471C2.70971 14.0769 2.07692 14.7097 1.74707 15.5059C1.639 15.7668 1.57159 16.0927 1.53613 16.6123C1.50022 17.1387 1.5 17.8079 1.5 18.75C1.5 19.1642 1.16421 19.5 0.75 19.5C0.335786 19.5 6.62728e-09 19.1642 6.62728e-09 18.75C6.62728e-09 17.8286 -0.000139445 17.1 0.0400391 16.5107C0.0806934 15.9149 0.165042 15.4067 0.361328 14.9326C0.843424 13.7687 1.76873 12.8434 2.93262 12.3613C3.40666 12.165 3.91489 12.0807 4.51074 12.04C5.09995 11.9999 5.82859 12 6.75 12H10.75Z"
          fill="currentColor"
        />
        <path
          d="M17.2197 12.2197C17.5126 11.9268 17.9874 11.9268 18.2803 12.2197C18.5732 12.5126 18.5732 12.9874 18.2803 13.2803L16.5605 15H20.75C21.1642 15 21.5 15.3358 21.5 15.75C21.5 16.1642 21.1642 16.5 20.75 16.5H16.5605L18.2803 18.2197C18.5732 18.5126 18.5732 18.9874 18.2803 19.2803C17.9874 19.5732 17.5126 19.5732 17.2197 19.2803L14.2197 16.2803C13.9268 15.9874 13.9268 15.5126 14.2197 15.2197L17.2197 12.2197Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.25 0C10.8734 0 13 2.12665 13 4.75C13 7.37335 10.8734 9.5 8.25 9.5C5.62665 9.5 3.5 7.37335 3.5 4.75C3.5 2.12665 5.62665 0 8.25 0ZM8.25 1.5C6.45507 1.5 5 2.95507 5 4.75C5 6.54493 6.45507 8 8.25 8C10.0449 8 11.5 6.54493 11.5 4.75C11.5 2.95507 10.0449 1.5 8.25 1.5Z"
          fill="currentColor"
        />
        <path
          d="M13.5547 0.759766C13.7101 0.375844 14.1473 0.190347 14.5312 0.345703C16.2706 1.04979 17.5 2.75538 17.5 4.75C17.5 6.74462 16.2706 8.45021 14.5312 9.1543C14.1473 9.30965 13.7101 9.12416 13.5547 8.74023C13.3996 8.35638 13.5849 7.91904 13.9687 7.76367C15.161 7.28092 16 6.11265 16 4.75C16 3.38735 15.161 2.21908 13.9687 1.73633C13.5849 1.58096 13.3996 1.14362 13.5547 0.759766Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UsersMinusIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M10.75 12C11.1642 12 11.5 12.3358 11.5 12.75C11.5 13.1642 11.1642 13.5 10.75 13.5H6.75C5.80786 13.5 5.13868 13.5002 4.6123 13.5361C4.09273 13.5716 3.76676 13.639 3.50586 13.7471C2.70971 14.0769 2.07692 14.7097 1.74707 15.5059C1.639 15.7668 1.57159 16.0927 1.53613 16.6123C1.50022 17.1387 1.5 17.8079 1.5 18.75C1.5 19.1642 1.16421 19.5 0.75 19.5C0.335786 19.5 6.62728e-09 19.1642 6.62728e-09 18.75C6.62728e-09 17.8286 -0.000139445 17.1 0.0400391 16.5107C0.0806934 15.9149 0.165042 15.4067 0.361328 14.9326C0.843424 13.7687 1.76873 12.8434 2.93262 12.3613C3.40666 12.165 3.91489 12.0807 4.51074 12.04C5.09995 11.9999 5.82859 12 6.75 12H10.75Z"
          fill="currentColor"
        />
        <path
          d="M20.75 15C21.1642 15 21.5 15.3358 21.5 15.75C21.5 16.1642 21.1642 16.5 20.75 16.5H14.75C14.3358 16.5 14 16.1642 14 15.75C14 15.3358 14.3358 15 14.75 15H20.75Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.25 0C10.8734 0 13 2.12665 13 4.75C13 7.37335 10.8734 9.5 8.25 9.5C5.62665 9.5 3.5 7.37335 3.5 4.75C3.5 2.12665 5.62665 0 8.25 0ZM8.25 1.5C6.45507 1.5 5 2.95507 5 4.75C5 6.54493 6.45507 8 8.25 8C10.0449 8 11.5 6.54493 11.5 4.75C11.5 2.95507 10.0449 1.5 8.25 1.5Z"
          fill="currentColor"
        />
        <path
          d="M13.5547 0.759766C13.7101 0.375844 14.1473 0.190347 14.5312 0.345703C16.2706 1.04979 17.5 2.75538 17.5 4.75C17.5 6.74462 16.2706 8.45021 14.5312 9.1543C14.1473 9.30965 13.7101 9.12416 13.5547 8.74023C13.3996 8.35638 13.5849 7.91904 13.9687 7.76367C15.161 7.28092 16 6.11265 16 4.75C16 3.38735 15.161 2.21908 13.9687 1.73633C13.5849 1.58096 13.3996 1.14362 13.5547 0.759766Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UsersPlusIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M10.75 12C11.1642 12 11.5 12.3358 11.5 12.75C11.5 13.1642 11.1642 13.5 10.75 13.5H6.75C5.80786 13.5 5.13868 13.5002 4.6123 13.5361C4.09273 13.5716 3.76676 13.639 3.50586 13.7471C2.70971 14.0769 2.07692 14.7097 1.74707 15.5059C1.639 15.7668 1.57159 16.0927 1.53613 16.6123C1.50022 17.1387 1.5 17.8079 1.5 18.75C1.5 19.1642 1.16421 19.5 0.75 19.5C0.335786 19.5 6.62728e-09 19.1642 6.62728e-09 18.75C6.62728e-09 17.8286 -0.000139445 17.1 0.0400391 16.5107C0.0806934 15.9149 0.165042 15.4067 0.361328 14.9326C0.843424 13.7687 1.76873 12.8434 2.93262 12.3613C3.40666 12.165 3.91489 12.0807 4.51074 12.04C5.09995 11.9999 5.82859 12 6.75 12H10.75Z"
          fill="currentColor"
        />
        <path
          d="M17.75 12C18.1642 12 18.5 12.3358 18.5 12.75V15H20.75C21.1642 15 21.5 15.3358 21.5 15.75C21.5 16.1642 21.1642 16.5 20.75 16.5H18.5V18.75C18.5 19.1642 18.1642 19.5 17.75 19.5C17.3358 19.5 17 19.1642 17 18.75V16.5H14.75C14.3358 16.5 14 16.1642 14 15.75C14 15.3358 14.3358 15 14.75 15H17V12.75C17 12.3358 17.3358 12 17.75 12Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.25 0C10.8734 0 13 2.12665 13 4.75C13 7.37335 10.8734 9.5 8.25 9.5C5.62665 9.5 3.5 7.37335 3.5 4.75C3.5 2.12665 5.62665 0 8.25 0ZM8.25 1.5C6.45507 1.5 5 2.95507 5 4.75C5 6.54493 6.45507 8 8.25 8C10.0449 8 11.5 6.54493 11.5 4.75C11.5 2.95507 10.0449 1.5 8.25 1.5Z"
          fill="currentColor"
        />
        <path
          d="M13.5547 0.759766C13.7101 0.375844 14.1473 0.190347 14.5312 0.345703C16.2706 1.04979 17.5 2.75538 17.5 4.75C17.5 6.74462 16.2706 8.45021 14.5312 9.1543C14.1473 9.30965 13.7101 9.12416 13.5547 8.74023C13.3996 8.35638 13.5849 7.91904 13.9687 7.76367C15.161 7.28092 16 6.11265 16 4.75C16 3.38735 15.161 2.21908 13.9687 1.73633C13.5849 1.58096 13.3996 1.14362 13.5547 0.759766Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserSquareIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 3.5C13.3734 3.5 15.5 5.62665 15.5 8.25C15.5 10.8734 13.3734 13 10.75 13C8.12665 13 6 10.8734 6 8.25C6 5.62665 8.12665 3.5 10.75 3.5ZM10.75 5C8.95508 5 7.5 6.45508 7.5 8.25C7.5 10.0449 8.95508 11.5 10.75 11.5C12.5449 11.5 14 10.0449 14 8.25C14 6.45508 12.5449 5 10.75 5Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9502 1.74496e-06C16.7778 1.6534e-06 17.4436 -0.000968058 17.9814 0.0429705C18.5281 0.0876302 19.008 0.182866 19.4522 0.409181C20.1578 0.768706 20.7313 1.34225 21.0908 2.04785C21.3171 2.49205 21.4124 2.97195 21.457 3.51856C21.501 4.05639 21.5 4.72222 21.5 5.54981V15.9502C21.5 16.7778 21.501 17.4436 21.457 17.9814C21.4124 18.5281 21.3171 19.008 21.0908 19.4522C20.7313 20.1578 20.1578 20.7313 19.4522 21.0908C19.2966 21.1701 19.1359 21.2342 18.9678 21.2852C18.2318 21.5081 17.2779 21.5 15.9502 21.5H5.54981C4.22206 21.5 3.26816 21.5081 2.53223 21.2852C2.36406 21.2342 2.20345 21.1701 2.04785 21.0908C1.34225 20.7313 0.768706 20.1578 0.409181 19.4522C0.182866 19.008 0.0876302 18.5281 0.0429705 17.9814C-0.000968058 17.4436 1.6534e-06 16.7778 1.74496e-06 15.9502V5.54981C1.65201e-06 4.72222 -0.000968203 4.05639 0.0429705 3.51856C0.0876303 2.97195 0.182866 2.49205 0.409181 2.04785C0.768706 1.34225 1.34225 0.768706 2.04785 0.409181C2.49205 0.182866 2.97195 0.0876303 3.51856 0.0429705C4.05639 -0.000968203 4.72222 1.65201e-06 5.54981 1.74496e-06H15.9502ZM7.75 16.5C6.785 16.5 6.41186 16.5037 6.11621 16.5625C4.82697 16.8189 3.81895 17.827 3.5625 19.1162C3.52433 19.3082 3.50869 19.5363 3.50293 19.9482C3.9499 19.995 4.57389 20 5.54981 20H15.9502C16.9254 20 17.5492 19.9949 17.9961 19.9482C17.9903 19.5363 17.9757 19.3082 17.9375 19.1162C17.6811 17.827 16.673 16.8189 15.3838 16.5625C15.0881 16.5037 14.715 16.5 13.75 16.5H7.75ZM5.54981 1.5C4.69746 1.5 4.10322 1.50029 3.64063 1.53809C3.1868 1.57517 2.92602 1.64449 2.72852 1.74512C2.30515 1.96083 1.96083 2.30515 1.74512 2.72852C1.64449 2.92602 1.57517 3.1868 1.53809 3.64063C1.50029 4.10322 1.5 4.69746 1.5 5.54981V15.9502C1.5 16.8025 1.50029 17.3968 1.53809 17.8594C1.57517 18.3132 1.64449 18.574 1.74512 18.7715C1.82535 18.929 1.92289 19.076 2.03613 19.209C2.0492 19.0729 2.06648 18.9456 2.09082 18.8232C2.46563 16.939 3.93896 15.4656 5.82324 15.0908C6.30035 14.9959 6.85665 15 7.75 15H13.75C14.6434 15 15.1997 14.9959 15.6768 15.0908C17.561 15.4656 19.0344 16.939 19.4092 18.8232C19.4335 18.9456 19.4498 19.0729 19.4629 19.209C19.5763 19.0758 19.6746 18.9291 19.7549 18.7715C19.8555 18.574 19.9248 18.3132 19.9619 17.8594C19.9997 17.3968 20 16.8025 20 15.9502V5.54981C20 4.69746 19.9997 4.10322 19.9619 3.64063C19.9248 3.1868 19.8555 2.92602 19.7549 2.72852C19.5392 2.30515 19.1949 1.96083 18.7715 1.74512C18.574 1.64449 18.3132 1.57517 17.8594 1.53809C17.3968 1.50029 16.8025 1.5 15.9502 1.5H5.54981Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UsersRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M10.75 12C11.1642 12 11.5 12.3358 11.5 12.75C11.5 13.1642 11.1642 13.5 10.75 13.5H6.75C5.80786 13.5 5.13868 13.5002 4.6123 13.5361C4.09273 13.5716 3.76676 13.639 3.50586 13.7471C2.70971 14.0769 2.07692 14.7097 1.74707 15.5059C1.639 15.7668 1.57159 16.0927 1.53613 16.6123C1.50022 17.1387 1.5 17.8079 1.5 18.75C1.5 19.1642 1.16421 19.5 0.75 19.5C0.335786 19.5 6.62728e-09 19.1642 6.62728e-09 18.75C6.62728e-09 17.8286 -0.000139445 17.1 0.0400391 16.5107C0.0806934 15.9149 0.165042 15.4067 0.361328 14.9326C0.843424 13.7687 1.76873 12.8434 2.93262 12.3613C3.40666 12.165 3.91489 12.0807 4.51074 12.04C5.09995 11.9999 5.82859 12 6.75 12H10.75Z"
          fill="currentColor"
        />
        <path
          d="M17.2197 12.2197C17.5126 11.9268 17.9874 11.9268 18.2803 12.2197L21.2803 15.2197C21.5732 15.5126 21.5732 15.9874 21.2803 16.2803L18.2803 19.2803C17.9874 19.5732 17.5126 19.5732 17.2197 19.2803C16.9268 18.9874 16.9268 18.5126 17.2197 18.2197L18.9395 16.5H14.75C14.3358 16.5 14 16.1642 14 15.75C14 15.3358 14.3358 15 14.75 15H18.9395L17.2197 13.2803C16.9268 12.9874 16.9268 12.5126 17.2197 12.2197Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.25 0C10.8734 0 13 2.12665 13 4.75C13 7.37335 10.8734 9.5 8.25 9.5C5.62665 9.5 3.5 7.37335 3.5 4.75C3.5 2.12665 5.62665 0 8.25 0ZM8.25 1.5C6.45507 1.5 5 2.95507 5 4.75C5 6.54493 6.45507 8 8.25 8C10.0449 8 11.5 6.54493 11.5 4.75C11.5 2.95507 10.0449 1.5 8.25 1.5Z"
          fill="currentColor"
        />
        <path
          d="M13.5547 0.759766C13.7101 0.375844 14.1473 0.190347 14.5312 0.345703C16.2706 1.04979 17.5 2.75538 17.5 4.75C17.5 6.74462 16.2706 8.45021 14.5312 9.1543C14.1473 9.30965 13.7101 9.12416 13.5547 8.74023C13.3996 8.35638 13.5849 7.91904 13.9687 7.76367C15.161 7.28092 16 6.11265 16 4.75C16 3.38735 15.161 2.21908 13.9687 1.73633C13.5849 1.58096 13.3996 1.14362 13.5547 0.759766Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UsersUpIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M10.75 12C11.1642 12 11.5 12.3358 11.5 12.75C11.5 13.1642 11.1642 13.5 10.75 13.5H6.75C5.80786 13.5 5.13868 13.5002 4.6123 13.5361C4.09273 13.5716 3.76676 13.639 3.50586 13.7471C2.70971 14.0769 2.07692 14.7097 1.74707 15.5059C1.639 15.7668 1.57159 16.0927 1.53613 16.6123C1.50022 17.1387 1.5 17.8079 1.5 18.75C1.5 19.1642 1.16421 19.5 0.75 19.5C0.335786 19.5 6.62728e-09 19.1642 6.62728e-09 18.75C6.62728e-09 17.8286 -0.000139445 17.1 0.0400391 16.5107C0.0806934 15.9149 0.165042 15.4067 0.361328 14.9326C0.843424 13.7687 1.76873 12.8434 2.93262 12.3613C3.40666 12.165 3.91489 12.0807 4.51074 12.04C5.09995 11.9999 5.82859 12 6.75 12H10.75Z"
          fill="currentColor"
        />
        <path
          d="M17.2764 12.168C17.5709 11.9277 18.0057 11.9451 18.2803 12.2197L21.2803 15.2197C21.5732 15.5126 21.5732 15.9874 21.2803 16.2803C20.9874 16.5732 20.5126 16.5732 20.2197 16.2803L18.5 14.5605V18.75C18.5 19.1642 18.1642 19.5 17.75 19.5C17.3358 19.5 17 19.1642 17 18.75V14.5605L15.2803 16.2803C14.9874 16.5732 14.5126 16.5732 14.2197 16.2803C13.9268 15.9874 13.9268 15.5126 14.2197 15.2197L17.2197 12.2197L17.2764 12.168Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.25 0C10.8734 0 13 2.12665 13 4.75C13 7.37335 10.8734 9.5 8.25 9.5C5.62665 9.5 3.5 7.37335 3.5 4.75C3.5 2.12665 5.62665 0 8.25 0ZM8.25 1.5C6.45507 1.5 5 2.95507 5 4.75C5 6.54493 6.45507 8 8.25 8C10.0449 8 11.5 6.54493 11.5 4.75C11.5 2.95507 10.0449 1.5 8.25 1.5Z"
          fill="currentColor"
        />
        <path
          d="M13.5547 0.759766C13.7101 0.375844 14.1473 0.190347 14.5312 0.345703C16.2706 1.04979 17.5 2.75538 17.5 4.75C17.5 6.74462 16.2706 8.45021 14.5312 9.1543C14.1473 9.30965 13.7101 9.12416 13.5547 8.74023C13.3996 8.35638 13.5849 7.91904 13.9687 7.76367C15.161 7.28092 16 6.11265 16 4.75C16 3.38735 15.161 2.21908 13.9687 1.73633C13.5849 1.58096 13.3996 1.14362 13.5547 0.759766Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UsersXIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M10.75 12C11.1642 12 11.5 12.3358 11.5 12.75C11.5 13.1642 11.1642 13.5 10.75 13.5H6.75C5.80786 13.5 5.13868 13.5002 4.6123 13.5361C4.09273 13.5716 3.76676 13.639 3.50586 13.7471C2.70971 14.0769 2.07692 14.7097 1.74707 15.5059C1.639 15.7668 1.57159 16.0927 1.53613 16.6123C1.50022 17.1387 1.5 17.8079 1.5 18.75C1.5 19.1642 1.16421 19.5 0.75 19.5C0.335786 19.5 6.62728e-09 19.1642 6.62728e-09 18.75C6.62728e-09 17.8286 -0.000139445 17.1 0.0400391 16.5107C0.0806934 15.9149 0.165042 15.4067 0.361328 14.9326C0.843424 13.7687 1.76873 12.8434 2.93262 12.3613C3.40666 12.165 3.91489 12.0807 4.51074 12.04C5.09995 11.9999 5.82859 12 6.75 12H10.75Z"
          fill="currentColor"
        />
        <path
          d="M19.7197 13.2197C20.0126 12.9268 20.4874 12.9268 20.7803 13.2197C21.0732 13.5126 21.0732 13.9874 20.7803 14.2803L18.8105 16.25L20.7803 18.2197C21.0732 18.5126 21.0732 18.9874 20.7803 19.2803C20.4874 19.5732 20.0126 19.5732 19.7197 19.2803L17.75 17.3105L15.7803 19.2803C15.4874 19.5732 15.0126 19.5732 14.7197 19.2803C14.4268 18.9874 14.4268 18.5126 14.7197 18.2197L16.6895 16.25L14.7197 14.2803C14.4268 13.9874 14.4268 13.5126 14.7197 13.2197C15.0126 12.9268 15.4874 12.9268 15.7803 13.2197L17.75 15.1895L19.7197 13.2197Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.25 0C10.8734 0 13 2.12665 13 4.75C13 7.37335 10.8734 9.5 8.25 9.5C5.62665 9.5 3.5 7.37335 3.5 4.75C3.5 2.12665 5.62665 0 8.25 0ZM8.25 1.5C6.45507 1.5 5 2.95507 5 4.75C5 6.54493 6.45507 8 8.25 8C10.0449 8 11.5 6.54493 11.5 4.75C11.5 2.95507 10.0449 1.5 8.25 1.5Z"
          fill="currentColor"
        />
        <path
          d="M13.5547 0.759766C13.7101 0.375844 14.1473 0.190347 14.5312 0.345703C16.2706 1.04979 17.5 2.75538 17.5 4.75C17.5 6.74462 16.2706 8.45021 14.5312 9.1543C14.1473 9.30965 13.7101 9.12416 13.5547 8.74023C13.3996 8.35638 13.5849 7.91904 13.9687 7.76367C15.161 7.28092 16 6.11265 16 4.75C16 3.38735 15.161 2.21908 13.9687 1.73633C13.5849 1.58096 13.3996 1.14362 13.5547 0.759766Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserUp01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M10.75 12.5C11.1643 12.5 11.5 12.8358 11.5 13.25C11.5 13.6642 11.1643 14 10.75 14H6.25005C4.80011 14 4.24116 14.0079 3.80669 14.1396C2.76801 14.4547 1.95478 15.268 1.6397 16.3066C1.50794 16.7411 1.50005 17.3 1.50005 18.75C1.50005 19.1642 1.16426 19.5 0.750047 19.5C0.335856 19.5 4.73066e-05 19.1642 4.73066e-05 18.75C4.72912e-05 17.4091 -0.00849882 16.5722 0.204149 15.8711C0.664658 14.353 1.85306 13.1646 3.37114 12.7041C4.07221 12.4915 4.90912 12.5 6.25005 12.5H10.75Z"
          fill="currentColor"
        />
        <path
          d="M17.2764 12.168C17.571 11.9277 18.0057 11.9451 18.2803 12.2197L21.2803 15.2197C21.5732 15.5126 21.5732 15.9874 21.2803 16.2803C20.9874 16.5731 20.5127 16.5732 20.2198 16.2803L18.5 14.5605V18.75C18.5 19.1642 18.1643 19.5 17.75 19.5C17.3359 19.5 17 19.1642 17 18.75V14.5605L15.2803 16.2803C14.9874 16.5731 14.5127 16.5732 14.2198 16.2803C13.9269 15.9874 13.9269 15.5126 14.2198 15.2197L17.2198 12.2197L17.2764 12.168Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75005 0C11.6495 0 14 2.3505 14 5.25C14 8.1495 11.6495 10.5 8.75005 10.5C5.85057 10.5 3.50005 8.14948 3.50005 5.25C3.50005 2.35052 5.85057 2.55776e-05 8.75005 0ZM8.75005 1.5C6.679 1.50003 5.00005 3.17895 5.00005 5.25C5.00005 7.32105 6.679 8.99997 8.75005 9C10.8211 9 12.5 7.32107 12.5 5.25C12.5 3.17893 10.8211 1.5 8.75005 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserUp02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M9.9502 12.0001C10.7778 12.0001 11.4436 11.9991 11.9814 12.043C12.528 12.0877 13.008 12.1829 13.4522 12.4092C14.1577 12.7688 14.7313 13.3423 15.0908 14.0479C15.3171 14.4921 15.4124 14.9721 15.457 15.5186C15.501 16.0564 15.5 16.7223 15.5 17.5499V18.7501C15.5 19.1643 15.1642 19.5001 14.75 19.5001C14.3358 19.5001 14 19.1643 14 18.7501V17.5499C14 16.6976 13.9997 16.1033 13.9619 15.6407C13.9248 15.1869 13.8555 14.9261 13.7549 14.7286C13.5392 14.3053 13.1948 13.9609 12.7715 13.7452C12.574 13.6446 12.3132 13.5752 11.8594 13.5382C11.3968 13.5004 10.8025 13.5001 9.9502 13.5001H5.54981C4.69746 13.5001 4.10322 13.5004 3.64063 13.5382C3.18684 13.5752 2.92602 13.6446 2.72852 13.7452C2.30518 13.9609 1.96084 14.3053 1.74512 14.7286C1.6445 14.9261 1.57517 15.1869 1.53809 15.6407C1.50029 16.1033 1.5 16.6976 1.5 17.5499V18.7501C1.5 19.1643 1.16422 19.5001 0.750002 19.5001C0.335789 19.5001 1.74488e-06 19.1643 1.74488e-06 18.7501V17.5499C1.56261e-06 16.7223 -0.000966165 16.0564 0.0429705 15.5186C0.0876342 14.9721 0.182882 14.4921 0.409181 14.0479C0.76871 13.3424 1.34228 12.7688 2.04785 12.4092C2.49204 12.1829 2.97197 12.0877 3.51856 12.043C4.05638 11.9991 4.72223 12.0001 5.54981 12.0001H9.9502Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75 1.00006C10.0972 1.00006 11.9999 2.90291 12 5.25006C12 7.59728 10.0972 9.50006 7.75 9.50006C5.40279 9.50006 3.5 7.59727 3.5 5.25006C3.50006 2.90291 5.40283 1.00007 7.75 1.00006ZM7.75 2.50006C6.23126 2.50007 5.00007 3.73134 5 5.25006C5 6.76885 6.23122 8.00006 7.75 8.00006C9.26879 8.00006 10.5 6.76885 10.5 5.25006C10.4999 3.73134 9.26875 2.50006 7.75 2.50006Z"
          fill="currentColor"
        />
        <path
          d="M17.2764 0.168034C17.5709 -0.0722097 18.0057 -0.0547377 18.2803 0.219791L21.2803 3.21979C21.5731 3.51267 21.5731 3.98744 21.2803 4.28034C20.9874 4.57323 20.5126 4.57323 20.2197 4.28034L18.5 2.56061V6.75006C18.5 7.16428 18.1642 7.50006 17.75 7.50006C17.3358 7.50006 17 7.16428 17 6.75006V2.56061L15.2803 4.28034C14.9874 4.57323 14.5126 4.57323 14.2197 4.28034C13.9269 3.98744 13.9269 3.51267 14.2197 3.21979L17.2197 0.219791L17.2764 0.168034Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserX01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M10.75 12.5C11.1643 12.5 11.5 12.8358 11.5 13.25C11.5 13.6642 11.1643 14 10.75 14H6.25005C4.80011 14 4.24116 14.0079 3.80669 14.1396C2.76801 14.4547 1.95478 15.268 1.6397 16.3066C1.50794 16.7411 1.50005 17.3 1.50005 18.75C1.50005 19.1642 1.16426 19.5 0.750047 19.5C0.335856 19.5 4.73066e-05 19.1642 4.73066e-05 18.75C4.72912e-05 17.4091 -0.00849882 16.5722 0.204149 15.8711C0.664658 14.353 1.85306 13.1646 3.37114 12.7041C4.07221 12.4915 4.90912 12.5 6.25005 12.5H10.75Z"
          fill="currentColor"
        />
        <path
          d="M19.7198 13.2197C20.0127 12.9268 20.4874 12.9269 20.7803 13.2197C21.0732 13.5126 21.0732 13.9874 20.7803 14.2803L18.8106 16.25L20.7803 18.2197C21.0732 18.5126 21.0732 18.9874 20.7803 19.2803C20.4874 19.5731 20.0127 19.5732 19.7198 19.2803L17.75 17.3105L15.7803 19.2803C15.4874 19.5731 15.0127 19.5732 14.7198 19.2803C14.4269 18.9874 14.4269 18.5126 14.7198 18.2197L16.6895 16.25L14.7198 14.2803C14.4269 13.9874 14.4269 13.5126 14.7198 13.2197C15.0127 12.9268 15.4874 12.9269 15.7803 13.2197L17.75 15.1895L19.7198 13.2197Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75005 0C11.6495 0 14 2.3505 14 5.25C14 8.1495 11.6495 10.5 8.75005 10.5C5.85057 10.5 3.50005 8.14948 3.50005 5.25C3.50005 2.35052 5.85057 2.55776e-05 8.75005 0ZM8.75005 1.5C6.679 1.50003 5.00005 3.17895 5.00005 5.25C5.00005 7.32105 6.679 8.99997 8.75005 9C10.8211 9 12.5 7.32107 12.5 5.25C12.5 3.17893 10.8211 1.5 8.75005 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UserX02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 3.25)">
        <path
          d="M9.9502 11C10.7778 11 11.4436 10.999 11.9814 11.043C12.5281 11.0876 13.008 11.1829 13.4522 11.4092C14.1578 11.7687 14.7313 12.3422 15.0908 13.0479C15.3171 13.4921 15.4124 13.9719 15.457 14.5186C15.501 15.0564 15.5 15.7222 15.5 16.5498V17.75C15.5 18.1642 15.1642 18.5 14.75 18.5C14.3358 18.5 14 18.1642 14 17.75V16.5498C14 15.6975 13.9997 15.1032 13.9619 14.6406C13.9248 14.1868 13.8555 13.926 13.7549 13.7285C13.5392 13.3052 13.1949 12.9608 12.7715 12.7451C12.574 12.6445 12.3132 12.5752 11.8594 12.5381C11.3968 12.5003 10.8025 12.5 9.9502 12.5H5.54981C4.69746 12.5 4.10322 12.5003 3.64063 12.5381C3.1868 12.5752 2.92602 12.6445 2.72852 12.7451C2.30515 12.9608 1.96083 13.3052 1.74512 13.7285C1.64449 13.926 1.57517 14.1868 1.53809 14.6406C1.50029 15.1032 1.5 15.6975 1.5 16.5498V17.75C1.5 18.1642 1.16422 18.5 0.750002 18.5C0.335789 18.5 1.7448e-06 18.1642 1.7448e-06 17.75V16.5498C1.65324e-06 15.7222 -0.000968203 15.0564 0.0429705 14.5186C0.0876302 13.9719 0.182866 13.4921 0.409181 13.0479C0.768706 12.3422 1.34225 11.7687 2.04785 11.4092C2.49205 11.1829 2.97195 11.0876 3.51856 11.043C4.05639 10.999 4.72222 11 5.54981 11H9.9502Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75 0C10.0972 0 12 1.90279 12 4.25C12 6.59721 10.0972 8.5 7.75 8.5C5.40279 8.5 3.5 6.59721 3.5 4.25C3.5 1.90279 5.40279 9.66398e-07 7.75 0ZM7.75 1.5C6.23122 1.5 5 2.73122 5 4.25C5 5.76878 6.23122 7 7.75 7C9.26879 7 10.5 5.76878 10.5 4.25C10.5 2.73122 9.26879 1.5 7.75 1.5Z"
          fill="currentColor"
        />
        <path
          d="M19.7197 0.219727C20.0126 -0.073166 20.4874 -0.0731654 20.7803 0.219727C21.0732 0.51262 21.0732 0.98738 20.7803 1.28027L18.8105 3.25L20.7803 5.21973C21.0732 5.51262 21.0732 5.98738 20.7803 6.28027C20.4874 6.57317 20.0126 6.57317 19.7197 6.28027L17.75 4.31055L15.7803 6.28027C15.4874 6.57317 15.0126 6.57317 14.7197 6.28027C14.4268 5.98738 14.4268 5.51262 14.7197 5.21973L16.6895 3.25L14.7197 1.28027C14.4268 0.987381 14.4268 0.512619 14.7197 0.219727C15.0126 -0.0731664 15.4874 -0.0731658 15.7803 0.219727L17.75 2.18945L19.7197 0.219727Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
